import {Component, OnInit, ViewChild} from '@angular/core';
import {MessagesService} from '../messages/messages.service';
import {SelectableLab} from '../masterdata/models/lab';
import {ErrorHandler} from '../utils/error-handler';
import {RunplanProcessService} from './runplan-process.service';
import {RunDetails} from './model/RunDetails';
import {saveAs as saveByFileSaver} from "file-saver";
import {DatePipe} from '@angular/common';
import {ConfirmationService, SelectItem} from 'primeng/api';
import {Comment} from './model/comment';
import {ActivatedRoute} from '@angular/router';
import {
  DP_COMPLETED,
  DP_STARTED,
  DP_WAITING,
  DUELESS_BLOCK_NAME,
  DUELESS_COLOR,
  DUEMORE_BLOCK_NAME,
  DUEMORE_COLOR,
  Lane,
  LaneBlock,
  LaneViewDataDTO,
  MANUAL_RUNQC_FINISHED,
  OVERDUE_BLOCK_NAME,
  OVERDUE_COLOR,
  PHIX_BLOCK_NAME,
  PHIX_COLOR,
  RUN_PLANNED,
  RUN_SCHEDULED
} from '../runplan-mainview/models/runPlanConstants';
import {RunPlanDto} from './model/RunPlanDto';
import rfdc from 'rfdc';
import {DirectPrintRequest} from '../print-plate-labels/ngs-print-request';
import {PrintPlateLabelService} from '../print-plate-labels/print-plate-labels-service';
import {Printer} from '../masterdata/models/printer';
import {PrintTemplateUtil} from '../common-services/print-template-utils';
import {LibLaneData, RunDPDataExportRequest} from './model/dp-data-export-request';
import {RunLaneUpdateDTO} from './model/RunLaneUpdateDTO';
import {MasterDataService} from '../masterdata/masterdata.service';
import {AuthUtil} from "../common-services/auth-util";
import * as jwt_decode from 'jwt-decode';
import {environment} from "../../environments/environment";
import {ManualRunQCEventPayload, ManualRunQCReviewRequest} from "./model/manual-runqc-review-request";

@Component({
  selector: 'app-runplan-process',
  templateUrl: './runplan-process.component.html',
  styleUrls: ['./runplan-process.component.css']
})
export class RunplanProcessComponent implements OnInit {

  @ViewChild('prepareDataOverlay') prepareDataOverlay: any;
  readonly buttonsRound= {"margin-bottom": "5px",
  "margin-top": "5px",
  "font-weight": "bold",
  "font-size": "14px",
  "padding": "7px",
  "width":"96%",
  "border-radius":"5px"
  }

  valueToSearch: string;
  blocked = false;
  selectedLabId: string;
  selectableLab: SelectableLab;
  selectedRun: RunDetails;

  showCommentDialog = false;
  urlCheck: string;
  previewComment: Comment;
  showPlateView = false;
  errorHandler: ErrorHandler = new ErrorHandler;
  puid: string;
  mapOfStatusSaves = new Map();
  comments: Comment[] = [];
  newComment: Comment;
  commentAvailable: boolean;
  laneViewMap = new Map<string, any[]>();
  laneViewData: RunPlanDto[] = [];
  lanetableVisible: boolean = false;
  laneViewLibraryData: any[];
  scrollableColsforLanelist: any[];
  scrollableColsforLibData: any[];
  laneViewList: any[];
  laneBlockMap = new Map();
  lanes: Lane[] = [];
  laneBlocks: LaneBlock[] = [];
  listofRunLibraries: any[] = [];
  commentPopup = false;
  seqRunFlag: boolean=true;
  loading : boolean = false;
  libraryIdTabledata: any[]=[];
  laneLibFilterValue:any;
  // rowsCount : any = 0;
  clone = rfdc();
  containerLibMap = new Map();
  laneSelectionMap = new Map();

  // table properties and values
  filterOptions: any[];
  selectedStates: string[] = [];
  fromDate: Date;
  toDate: Date;
  showFilter: boolean = true;
  run: any;
  runProcess: any[];
  librarySelectionList = [];
  expandedLane: string = null;
  runActionSelection: string;
  actionOptions: SelectItem[] = [];
  showRemoveLibsSideBar: boolean = false;
  removalLibraryObjects: any[] = [];
  removalLibraryIds: string[] = [];
  removalEmptyLibsMessage: string = null;
  libraryCount: number = 0;
  removelErrorReutrnMessage: string = null;
  removalContainedLibIds: string[] = [];

  userEmail: string = null;
  userPassword: string = null;
  processViewSidebar: boolean = false;
  sequencingRunContinuationValue: string;
  dateFormat: string;
  dateTimeFormat: string;
  calendarDateFormat: any;

  runStatusList:any[] = [];
  laneContainerLibIdMap = new Map();
  libLaneGXPMap: Map<string, any> = new Map<string, any>();
  laneAllLibsDPWaitingMap: Map<string, boolean> = new Map<string, boolean>();

  readonly libraryActionAllowedStatuses = [RUN_PLANNED, RUN_SCHEDULED, DP_STARTED];
  readonly FINAL_STATUSES = new Set(Array.from(["CANCELLED","REDO",'COMPLETED']));
  readonly  PREPARE_DATA_FOR_ANALYSIS_DISABLED_STATES =new Set(["RUN_PLANNED" , "DP_STARTED", "CANCELLED", "COMPLETED", "REDO",
  "SEQ_RUN_STARTED","SEQ_RUN_FINISHED","PA_STARTED","PREPARE_DATA_FOR_ANALYSIS","RUN_SCHEDULED"])
  readonly NON_FINAL_STATUSES =["SEQ_RUN_STARTED","SEQ_RUN_FINISHED","PA_STARTED","PA_FINISHED",
                                ,"RUN_SCHEDULED", "DP_STARTED", "DP_COMPLETED", "PREPARE_DATA_FOR_ANALYSIS",
                                "READY_FOR_RUNQC", "MANUAL_RUNQC_STARTED"]

  readonly DISABLE_ION_SEQUENCER_COMPLETE_RUNQC_REVIEW_FOR_STATUS = new Set(Array.from(["SEQ_RUN_STARTED", "SEQ_RUN_FINISHED", 
    "MANUAL_RUNQC_STARTED", "COMPLETED", "REDO", "CANCELLED"]));                            

  libraryQCMap: any;
  currentBusyLane: string = '';
  printerList: SelectItem[] = [];
  selectedPrinter: Printer = null;
  showLogFileUploadError: boolean = false;
  logFileErrorMessage: string = '';
  laneDPWaitingMap: Map<string, boolean> = new Map();

  librayAllSelectMap:object = {};

  qcStatuses:any[];
  selectedQCStatus:string;
  laneLibSelctedMap:Map<String,Array<any>> = new Map()
  laneQcStatusMap = new Map()

  readonly POOL_DISABLED_STATES = new Set(Array.from([RUN_PLANNED, RUN_SCHEDULED, DP_STARTED, DP_COMPLETED]));
  readonly DNP_DOWNLOAD_TYPE = "download_dnp_file";
  readonly PRIMARY_ANALYSIS_START_STATES =[ "RUN_PLANNED", "DP_STARTED", "CANCELED", "COMPLETED","REDO"] ;

  libraryReadsRemovalMap = {};

  showRunConfirmation = false;
  selectedRunCompletePopUpOptoion:string;
  selectedLaneIdForCompleteRun:string;
  laneAutoRunQCReportDetail:string="";
  laneManualRunQCCompletedDetail:string="";

  readonly dpStartedLaneStyle = {
    'background-color': 'white',
    'padding-left': '0em',
    'border-left': '0.857em solid #41827E'
  };

  readonly nonDPLaneStyle = {
    'background-color': 'white'
  };

  readonly dpWaitingRowStyle = {
    'background-color': '#F25B63'
  };

  manualPoolingPopUp: boolean = false;
  completionPoolId: string = null;
  completionLibraryBarcode: string = null;
  completionPlateBarcode: string = null;
  completionPlatePosition: string = null;
  libraryTdf: string = null;
  adviceString: string = null;
  thirdDilutionValue: number;
  libTdfMore: string[] = [];
  librarySuggestionMap: Map<string, number> = new Map();
  libraryTdfMap: Map<string, number> = new Map();
  showEbDilutionTable: boolean = false;
  disableDnPUpdate: boolean = true;
  currentlyUsedLane: LaneViewDataDTO = null;
  dnPErrors: string = null;
  showChangeConcentrationSidebar: boolean = false;
  barcodesToChangeConcentration: string[] = [];
  userConcentration: number;
  plateLibraryMap: Map<string, any> = new Map();
  libraryPlateMap: Map<string, any> = new Map();
  flowcellData: any;
  scannedFlowCellID: string;
  isValidMDMRole = false

  constructor(private activatedroute: ActivatedRoute, private _messagesService: MessagesService, private runplanProcessService: RunplanProcessService, private datepipe: DatePipe,
    private confirmationService: ConfirmationService, private printPlateLabelService: PrintPlateLabelService,
    private printTemplateUtil: PrintTemplateUtil, private mdmService: MasterDataService) { }

  setDateFormat(dateFormat){
      return   dateFormat.length>8  ? dateFormat.replace("yyyy","yy"): dateFormat.replace("yy","y");
    }

  ngOnInit() {
    this.commentAvailable = true;
    this.previewComment = new Comment();
    this.newComment = new Comment();

    this.puid = localStorage.getItem('PUID');
    this.selectableLab = JSON.parse(localStorage.getItem('lab'));
    this.calendarDateFormat =this.setDateFormat(this.selectableLab.lab.dateFormat.toLowerCase());
    this.selectedLabId = this.selectableLab.lab._id;
    this.dateFormat = this.selectableLab.lab.dateFormat;
    this.dateTimeFormat = this.selectableLab.lab.dateTimeFormat;
    this.populateMapOfStatusSaves();
    this.showPlateView=false;

    this.activatedroute.params.subscribe(params => {
      this.valueToSearch = params['id'];
      if(this.valueToSearch) {
        this.getDataForRunProcessing();
      }
    });

    this.scrollableColsforLanelist = [
      { 'header': 'LaneId', 'field': 'laneId', 'selected': false },
      { 'header': 'Due Date', 'field': 'dueDate', 'selected': false },
      { 'header': 'Const. ID', 'field': 'constraintId', 'selected': false },
      { 'header': 'Amount of Libs', 'field': 'totalLibIds', 'selected': false },
      { 'header': 'Reads', 'field': 'totalReadsCount', 'selected': false },
      { 'header': 'Phix', 'field': 'phixPercentage', 'selected': false },
      { 'header': '', 'field': 'rowExpand', 'selected': false }
    ]
    this.scrollableColsforLibData = [
      { 'header': 'Final Conc. pM', 'field': 'concentration', 'selected': false},
      { 'header': 'LibraryID', 'field': 'libraryId', 'selected': false },
      { 'header': 'Plate BC', 'field': 'plateBarcode', 'selected': false },
      { 'header': 'Project', 'field': 'projectName', 'selected': false },
      { 'header': 'Sample', 'field': 'sampleName', 'selected': false },
      { 'header': 'LibType', 'field': 'libraryType', 'selected': false},
      { 'header': 'Comment', 'field': 'comment', 'selected': false},
      { 'header': 'Planned Reads', 'field': 'missingReads', 'selected': false },
      { 'header': 'Relative Reads Deviation [%]', 'field': 'readDeviationRel', 'selected': false},
      { 'header':'Qc Status' ,'field':'manualRunQCStatus' ,'selected':false },
      { 'header': 'Status', 'field': 'status', 'selected': false },
      { 'header': 'Tag', 'field': 'tagInfo', 'selected': false },
      { 'header': 'Raw Data Due date', 'field': 'dueDateRawData', 'selected': false }
    ]

    this.actionOptions = [
      { label: 'Remove', value : 'remove' }
    ];

    this.filterOptions = [
      { label: 'SEQ_RUN_STARTED', value : 'SEQ_RUN_STARTED' },
      { label: 'SEQ_RUN_FINISHED', value : 'SEQ_RUN_FINISHED' },
      { label: 'PA_STARTED', value : 'PA_STARTED' },
      { label: 'PA_FINISHED', value : 'PA_FINISHED' },
      { label: 'REDO', value : 'REDO' },
      { label: 'COMPLETED', value : 'COMPLETED' },
      { label: 'CANCELLED', value : 'CANCELLED' },
      { label:'RUN_PLANNED' , value:'RUN_PLANNED'},
      { label:'RUN_SCHEDULED' , value:'RUN_SCHEDULED'},
      { label:'DP_STARTED' ,value:'DP_STARTED'} ,
      { label:'DP_COMPLETED' ,value:'DP_COMPLETED'} ,
      { label:'PREPARE_DATA_FOR_ANALYSIS' ,value:'PREPARE_DATA_FOR_ANALYSIS'},
      { label:'READY_FOR_RUNQC' ,value:'READY_FOR_RUNQC'} ,
      { label:'MANUAL_RUNQC_STARTED' ,value:'MANUAL_RUNQC_STARTED'},
      { label:'MANUAL_RUNQC_FINISHED' ,value:'MANUAL_RUNQC_FINISHED'}
    ]
    this.qcStatuses = [
      { label: "QC Passed", value : "QC Passed" },
      { label: 'QC Failed', value : 'QC Failed' }

    ]

    this.isValidMDMRole = this.checkIfLoggedInUserIsMDMAdmin()
    this.getRunIdStatusList();
    this.serviceCallForPrinterList();
  }



  populateMapOfStatusSaves() {
    this.mapOfStatusSaves.set("DP_STARTED", "dilutionAndPoolingStarted");
    this.mapOfStatusSaves.set("DP_COMPLETED", "dilutionAndPoolingCompleted");
    this.mapOfStatusSaves.set("PREPARE_DATA_FOR_ANALYSIS", "prepareDataForAnalysis");
    this.mapOfStatusSaves.set("SEQ_RUN_FINISHED", "seqRunFinished");
    this.mapOfStatusSaves.set("SEQ_RUN_STARTED", "seqRunStarted");
    this.mapOfStatusSaves.set("PA_STARTED", "primaryAnalysisStarted");
    this.mapOfStatusSaves.set("PA_FINISHED", "primaryAnalysisFinished");
    this.mapOfStatusSaves.set("RUN_REVIEW_STARTED", "runReviewStarted");
    this.mapOfStatusSaves.set("COMPLETED", "runReviewFinished");
    this.mapOfStatusSaves.set("MANUAL_RUNQC_STARTED","manualRunQCStarted");
  }

  seqRunFinished(status: string){
    this.selectedRun.sequencingRunFinishedPUID = this.puid;
    let date = new Date(this.selectedRun.sequencingRunStartedDate);
    date.setHours(date.getHours() + this.selectedRun.runDuration);
    this.selectedRun.sequencingRunFinishedDateTime = date;
    this.selectedRun.status = status;
    this.saveRun();
  }

  seqRunStarted(status: string){
    this.selectedRun.sequencingRunStartedPUID = this.puid;
    this.selectedRun.sequencingRunStartedDate = new Date();
    this.selectedRun.sequencingStarted = true;
    this.selectedRun.actualStartDate = this.selectedRun.sequencingRunStartedDate;
    let date = new Date(this.selectedRun.sequencingRunStartedDate);
    date.setHours(date.getHours() + this.selectedRun.runDuration);
    this.selectedRun.actualFinishDate = date;
    this.selectedRun.status = status;
    this.saveRun();
  }
  sortLane(laneId1:string ,laneId2):Number{
    let index1 = laneId1.trim().lastIndexOf(" ");
    let index2 = laneId2.trim().lastIndexOf(" ");
    return Number(laneId1.substring(index1+1)) - Number(laneId1.substring(index2+1))
  }

  setAutoRunQCReportLaneDetails(){

    this.selectedRun.runLanes.sort((d1, d2) => {
      if (d1.laneId < d2.laneId)
        return -1;
      else if (d1.laneId > d2.laneId)
        return 1;
      else
        return 0;
    });
    this.laneAutoRunQCReportDetail = ""
    this.laneManualRunQCCompletedDetail = ""
    this.selectedRun.runLanes.forEach(lane=>{
      this.laneAutoRunQCReportDetail += this.getLaneDatePuidString(lane.laneId ,lane.autoRunQCReportFinishDateTime,lane.autoRunQCReportFinishPUID);
      this.laneManualRunQCCompletedDetail += this.getLaneDatePuidString(lane.laneId ,lane.manualRunQCFinishedDateTime,lane.manualRunQCFinishedPUID);
    })
  }


  saveRun() {
    this.blocked = true;
    this.runplanProcessService.updateRunStatus(this.selectedRun).subscribe(
      results=>{
        this.selectedRun = results.data;
        this.setAutoRunQCReportLaneDetails();
        this._messagesService.addSuccessMessage({severity: 'success', summary:'Run status updated successfully!'});
        this.seqRunFlag = true;
        this.processViewSidebar = false;
        this.blocked = false;
        this.commentPopup= false;
      }, error => {
        this.handleError(error);
        this.commentPopup = false;

      }
    )
  }

  manualRunQCStarted(status:string){
   this.selectedRun.runReviewStartedDateTime = new Date();
    this.selectedRun.runReviewStartedPUID = this.puid;
    this.selectedRun.status = status;
    this.saveRun()
  }
  primaryAnalysisStarted(status: string){
    this.selectedRun.primaryAnalysisStartedDateTime = new Date();
    this.selectedRun.primaryAnalysisStartedPUID = this.puid;
    this.selectedRun.status = status;
    this.saveRun()
  }

  primaryAnalysisFinished(status: string){
    this.selectedRun.primaryAnalysisFinishedDateTime = new Date();
    this.selectedRun.primaryAnalysisFinishedPUID = this.puid;
    this.selectedRun.status = status;
    this.saveRun()
  }

  runReviewStarted(status: string){
    this.selectedRun.runReviewStartedDateTime = new Date();
    this.selectedRun.runReviewStartedPUID = this.puid;
    this.selectedRun.status = status;
    this.saveRun();
  }

  runReviewFinished(status: string){
    this.selectedRun.runReviewFinishedDateTime = new Date();
    this.selectedRun.runReviewFinishedPUID = this.puid;
    this.selectedRun.status = status;
    this.saveRun();
  }

  dilutionAndPoolingStarted(status: string) {
    // turn the view to lane view with D&P view in lane
    this.selectedRun.dilutionAndPoolingStartedDateTime = new Date();
    this.selectedRun.dilutionAndPoolingStartedPUID = this.puid;
    this.selectedRun.status = status;
    this.saveRunForDnP();
  }

  dilutionAndPoolingCompleted(status: string) {
    // need to check if all the lanes have completed their D&P or not. Show error for lanes not having completed their D&P
    this.selectedRun.dilutionAndPoolingCompletedDateTime = new Date();
    this.selectedRun.dilutionAndPoolingCompletedPUID = this.puid;
    this.selectedRun.status = status;
    this.saveRun();
  }

  searchForRunWIthFilter() {
    if (!this.valueToSearch || this.valueToSearch.trim() == '') {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Value Not Entered', detail: 'Please Enter the value to search.' });
      return;
    }
    this.getDataForRunProcessing();

  }



  getLaneDatePuidString(laneId:string,dateTime:any,puId:string):string{
    let laneSuffix ='NA'
    if(dateTime){
     laneSuffix = this.datepipe.transform(new Date(dateTime) ,'dd.MM.yyyy HH:mm:ss')+" "+puId
    }
     return laneId +": "+ laneSuffix+'<br>'
  }

  getDataForRunProcessing() {
    this.blocked = true;
    this.showPlateView=false;
    this.seqRunFlag = true;
    let runProcess = this.runplanProcessService.getRunForLabAndRunId(this.selectedLabId, this.valueToSearch.trim());
    runProcess.subscribe(results => {
      if (results.data) {
        this.selectedRun = results.data;
        this.setAutoRunQCReportLaneDetails()
        this.getLanesFromFlowCell();
        this.urlCheck = this.selectedRun.flowcell;
        this.comments = this.selectedRun.comments;
        this.previewComment = this.getPreviewComment();
        this.showCommentDialog = false;
        this.selectedQCStatus = null;
        this.valueToSearch = '';
        this.setSequencingRunStartedFlag();

      } else {
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Run Not Found', detail: 'Run not found with RunID ' + this.valueToSearch });
      }
      this.blocked = false;
    }, error => {
      this.blocked=false;
      let message = this.errorHandler.handleError(error);
      this._messagesService.addErrorMessage(message);
    }
    )
  }

  private setSequencingRunStartedFlag() {
    if (this.selectedRun.status === 'PREPARE_DATA_FOR_ANALYSIS' && ((this.checkForONTRun() && this.selectedRun.analysisSheetFileURL) || (this.selectedRun.sampleSheetURL && this.selectedRun.sampleSheetURLV2 && this.selectedRun.runConfigURL))) {
      this.seqRunFlag = false;
    }
  }

  getLanesFromFlowCell() {
    this.mdmService.getLanesFromFlowCell(this.selectedLabId, this.selectedRun.flowCellName).subscribe(
      result=>{
        this.flowcellData = result.data
      }, error=>{

      }
    )
  }

  searchButtonDisabledIf() {
    return !(this.valueToSearch && this.valueToSearch.trim() != '');
  }

  getViewPlateIcon(plateViewStatus: boolean) {
    if (this.showPlateView) {
      return 'pi pi-list';
    } else {
      return 'pi pi-th-large';
    }
  }

  getPlateViewButtonLabel(plateView: boolean) {
    if (plateView) {
      return 'View Process';
    } else {
      return 'View Lane';
    }
  }

  saveRunStatus(status: string) {
    if (this.selectedRun.runId == null || this.selectedRun.runId == undefined) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Run ID Empty', detail: 'Please enter Run ID to save' });
      return;
    }

    if (!this.isPUIDPresnt()) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'User ID Empty', detail: 'Please enter User ID to save' });
      return;
    }
    if(this.selectedRun.isSampleSheetEventSentToMinnt && status=='DP_STARTED'){
      return;
    }
    this.saveRunStatusAction(status);
  }

  saveRunStatusAction(status: string) {
    if (this.selectedRun.disassembling && status === 'PREPARE_DATA_FOR_ANALYSIS' && !this.checkForONTRun()) {
      let dialogMessage = 'This preparation had been performed successfully at a previous time. Do you really want to restart this preparation and create new SampleSheet and RunConfig files?' + "<br/>" +
        'Note: Restarting will replace existing links in this view.';
      this.confirmationService.confirm({
        message: dialogMessage,
        header: 'Confirmation',
        icon: 'fa fa-question-circle',
        accept: () => {
          let functionName = this.mapOfStatusSaves.get(status);
          this[functionName](status);
        },
        reject: () => {

        }
      });
    } else {
      let functionName = this.mapOfStatusSaves.get(status);
      this[functionName](status);
    }
  }

  private saveSampleSheetData() {
    if (!this.selectedRun.runLanes || this.selectedRun.runLanes.length == 0) {
      this._messagesService.addErrorMessage({ severity: "error", summary: "No Libraries in Run", detail: "No libraries found in the run. Please select appropriate run." });
      return;
    }

    this.selectedRun.constraintIds = this.getConstraintIds(this.selectedRun);
    this.selectedRun.labName = this.selectableLab.lab.name
    this.blocked = true;
    let prepareData = this.runplanProcessService.prepareDataForAnalysis(this.selectedRun);
    prepareData.subscribe(results => {
      if (results.data) {
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: "RunConfig and Samplesheet Creation Successful!",
          detail: 'Run ID: ' + this.selectedRun.runId
        });
        this.selectedRun = results.data;
        this.prepareDataOverlay.hide()
       this.setSequencingRunStartedFlag();
        this.blocked = false;
      }
    }, error => {
      this.prepareDataOverlay.hide()
      this.valueToSearch = this.selectedRun.runId;
      this.seqRunFlag = true;
      this.getDataForRunProcessing();
      this.handleError(error);
    }
    );
  }

  isPUIDPresnt() {
    return (this.puid != null && this.puid != undefined && this.puid != '');
  }

  downloadSheet(fileName: string, downloadType: string) {
    const dataToUpload = { "fileName": fileName, "runId": this.selectedRun.runId, "lab": this.selectableLab.lab.name};
    let jsonDataString: string = JSON.stringify(dataToUpload);
    this.blocked = true;
    this.runplanProcessService.downloadSampleSheet(downloadType, jsonDataString).subscribe(
      result => {
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Intiating File download',
          detail: '',
        });
        var blob = new Blob([result.fileContent], { type: 'application/octet-stream' });
        this.blocked = false;
        saveByFileSaver(blob, fileName);
      },
      error => {
        this.blocked = false;
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'File Not Found', detail: 'File not present on blob ' + fileName });
      }
    )
  }

  private handleError(error: any) {
    this.blocked = false;
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  prepareDataForAnalysis(status: string) {
    if(this.selectedRun.status === "PA_STARTED" || this.selectedRun.status === "SEQ_RUN_FINISHED" || this.selectedRun.status === "SEQ_RUN_STARTED"){
      this.dataSetForprepareDataForAnalysis();
    }else{
      this.dataSetForprepareDataForAnalysis();
      this.selectedRun.status=status;
    }

    this.saveSampleSheetData();
  }

dataSetForprepareDataForAnalysis(){
  this.selectedRun.prepareDataForAnalysisPUID = this.puid;
  this.selectedRun.prepareDataForAnalysisDate = new Date();
}

  downloadTemplate(event: any, downloadType: string) {

    var target = event.target || event.srcElement || event.currentTarget;
    var idAttr = target.attributes.id;
    var value = idAttr.nodeValue;
    var comment = document.getElementById(value).innerText;

    this.downloadSheet(comment, downloadType);

  }

  getFileNameFromComment(comment: string) {
    var file = comment.substring(0, comment.indexOf(' '));

    if ("Request" === file) {
      var a = comment.split(". ");
      file = a[1].trim();
      file = file.substring(0, file.indexOf(' '));
    }
    return file;
  }

  getPreviewComment() {
    let comment = new Comment();
    if (this.comments && this.comments.length > 0) {
      this.commentAvailable = false;
      comment = this.comments[this.comments.length - 1];
    }
    else if (!this.comments || this.comments.length == 0) {
      this.commentAvailable = true;
      comment.puid = '';
      comment.commentDate = null;
      comment.userComment = 'No Comments added';
      this.comments =  [comment];
    } else {
      comment.userComment = 'No Comments added yet'
    }
    return comment;
  }

  showComments() {
    this.showCommentDialog = true;
  }

  isCommentViewDisabled() {
    return !this.selectedRun;

  }
  getConstraintIds(run: RunDetails) {
    let constraintIdSet: Set<string> = new Set<string>();
    run.runLanes.forEach(lane => {
      let runLane = lane.runLanes[0];
      if (runLane?.constratintType && runLane?.constratintType == "product") {
        constraintIdSet.add(runLane.constraintId);
      } else {
        constraintIdSet.add("none");
      }
    });

    return Array.from(constraintIdSet);
  }
  togglePlateView() {
    this.laneBlocks = [];
    this.showPlateView = !this.showPlateView;
    if (this.showPlateView) {
      this.insertConcentrationChangeActionIfRequired();
      this.getDataForLaneView();
    }
  }

  insertConcentrationChangeActionIfRequired() {
    if(this.selectedRun.status == DP_STARTED) {
      this.actionOptions = [];
      this.actionOptions.push({label: 'Remove', value: 'remove'});
      this.actionOptions.push({label: 'Change Concentration', value : 'changeConcentration' });
    } else {
      this.actionOptions = [{
        label: 'Remove', value : 'remove'
      }];
    }
  }

  getDataForLaneView() {
    this.runActionSelection = null;
    this.expandedLane = null;
    this.laneBlocks = [];
    let map = {};
    this.selectedRun.runLanes.forEach((laneData: any) => {
      this.listofRunLibraries = [];
      laneData.runLanes.forEach(ipus => {
        this.listofRunLibraries = this.listofRunLibraries.concat(ipus.libraryId)
      });
      map[laneData.laneId] = this.listofRunLibraries
    });
    let dataToExport = { "labId": this.selectedLabId, "runId": this.selectedRun.runId, "mapOfrunWithLibraries": map};

    this.blocked = true;
    this.runplanProcessService.getListOfLaneView(dataToExport).subscribe( results => {
      if (results?.data?.libData) {
        this.createLaneViewMap(results.data.libData , results.data.qcData.dnpValues);
         this.setLaneViewData(results.data.qcData?.laneQCData);
        this.libraryQCMap = results.data.qcData?.librarySeqInfo;
        this.lanePlacement();
      }
      this.blocked = false;
    }, error => {
      this.handleError(error);
    });
  }

  createLaneViewMap(result: any ,laneStatus:any) {
    this.laneViewMap =  new Map();
    this.containerLibMap = new Map();
    this.laneSelectionMap = new Map();
    this.laneContainerLibIdMap = new Map();
    this.laneDPWaitingMap = new Map();
    this.librarySelectionList = [];
    this.libLaneGXPMap = new Map();
    this.laneAllLibsDPWaitingMap = new Map();

    for(let [key, value] of Object.entries(result)) {
      if(value && value["NO_CONTAINER"]) {
        this.laneViewMap.set(key, this.clone(value["NO_CONTAINER"]));
        this.laneSelectionMap.set(key, []);
        this.laneContainerLibIdMap.set(key, []);
        this.laneAllLibsDPWaitingMap.set(key, true);
        for(let [k, v] of Object.entries(value)) {
          if(k != "NO_CONTAINER") {
            this.containerLibMap.set(k, v);
          } else {
            for(let lib of v) {
              if(lib["containedLibs"] && lib["containedLibs"].length > 0) {
                let containerLibs = this.laneContainerLibIdMap.get(key);
                containerLibs.push(lib["libraryId"]);
                this.laneContainerLibIdMap.set(key, containerLibs);
              }
              if(lib["status"] != DP_WAITING){
                this.laneAllLibsDPWaitingMap.set(key, false);
              }
              if(this.selectedRun.status == DP_STARTED && lib['status'] == DP_WAITING) {
                this.laneDPWaitingMap.set(key, true);
              }
              this.libLaneGXPMap.set(lib['libraryBarcode'], {"lane":key,"gxp":lib['gxp']});
            }
          }
        }
      }
    }
    this.setQCStatusDataMap(laneStatus)
  }

  setQCStatusDataMap(laneData:any){
    this.laneQcStatusMap = new Map();
    for(let [k,v] of Object.entries(laneData)){
      this.setLaneQCStatusMap(k,v['statusOfTheLane'])
    }

  }

  setLaneViewData(qcLaneData: any) {
    this.laneViewData = [];
    this.selectedRun.runLanes.sort((d1, d2) => {
      if (d1.laneId < d2.laneId)
        return -1;
      else if (d1.laneId > d2.laneId)
        return 1;
      else
        return 0;
    });
    this.laneViewList = [];
    let totalReadCapacity = 0;
    let totalOccupiedCapacity;
    let laneBlock = new LaneBlock();
    laneBlock.name = PHIX_BLOCK_NAME;
    laneBlock.color = PHIX_COLOR;
    laneBlock.weightPercentage = 1;
    this.selectedRun.runLanes.forEach((lane: any) => {
      let laneData = new LaneViewDataDTO();
      let totalReads = 0;
      laneData.gxp =lane.gxp
      if(lane.runLanes.length > 0){
        let runLaneAtFirstIndex = lane.runLanes[0];
        lane['runLanes'].forEach(run => {
          totalReads += run.weight;
          laneData.totalLibIds += run.libraryId.length;
        });

        totalReadCapacity = runLaneAtFirstIndex.laneCapacity

        totalOccupiedCapacity = totalReads + runLaneAtFirstIndex.occupiedCapacity;

        laneData.laneId = lane.laneId;
        laneData.allLibsDPWaiting = this.laneAllLibsDPWaitingMap.get(laneData.laneId);
        laneData.constraintId = runLaneAtFirstIndex.constraintId;
        let occupiedPercentage = Math.round(((totalOccupiedCapacity / totalReadCapacity) * 100) * 100) / 100;

        laneData.totalReadsCount = this.abbreviateNumber(totalOccupiedCapacity) + '  ( ' + occupiedPercentage + ' %)';

        laneData.phixPercentage = runLaneAtFirstIndex.phiXPercentage;
        laneData.userInputFinalConc = lane.finalConcentration;
        laneData.finalConcentration = lane.finalConcentration;
        laneData.statusOfTheLane = lane.statusOfTheLane;
        laneData.eppiPosition = lane.eppiPosition;
        laneData.hamiltonFileGenerated = lane.hamiltonFileGenerated;
        laneData.plateBarcodesForPoolingRun = lane.plateBarcodesForPoolingRun

        if(!lane.dnPfiles) {
          lane.dnPfiles = [];
          laneData.dnPfiles = [];
        } else {
          laneData.dnPfiles = this.clone(lane.dnPfiles);
        }

        if(!lane.poolingRun) {
          lane.poolingRun = 0;
          laneData.poolingRun = 0;
        } else {
          laneData.poolingRun = lane.poolingRun;
        }

        this.initializeLaneQCValues(qcLaneData[lane['laneId']], laneData);
        this.laneViewList.push(laneData);
      } else {
        laneData.laneId = lane.laneId;
        laneData.totalReadsCount = 0 + '  ( 0 %)';
        laneData.phixPercentage = 0
        laneData.eppiPosition = lane.eppiPosition;
        laneData.hamiltonFileGenerated = lane.hamiltonFileGenerated;
        this.laneViewList.push(laneData);
      }
    });
  }

  initializeLaneQCValues(qcLaneData: any, laneData: LaneViewDataDTO) {
    if(qcLaneData) {
      laneData.q30Rate = this.roundOff(qcLaneData['q30Rate']);
      laneData.readsForLane = this.convertNumber(qcLaneData['readsForLane']);
      laneData.unknownReads = this.convertNumber(qcLaneData['unknownReads']);
      laneData.totalReads = this.convertNumber(qcLaneData['totalReads'])
      laneData.unknownTags = this.getMapOfUnknownTags(qcLaneData['unknownTags']);
    }
  }

  getMapOfUnknownTags(unknownTags: any) {
    if(unknownTags) {
      return new Map(Object.entries(unknownTags));
    } else {
      return new Map();
    }
  }

  roundOff(data: number) {
    if(data) {
      return data.toFixed(2);
    } else {
      return "N/A";
    }
  }

  convertNumber(data: String) {
    if(data) {
      return Number(data).toLocaleString("en-US");
    } else {
      return "N/A";
    }
  }

  abbreviateNumber(value: number) {
    let newValue = value;
    const suffixes = ["", "K", "M"];
    let suffixNum = 0;
    if (newValue >= 1000000) {
      suffixNum = 2;
      while (newValue >= 1000000) {
        newValue /= 1000000;
      }
    } else if (newValue >= 1000) {
      suffixNum = 1;
      while (newValue >= 1000) {
        newValue /= 1000;
      }
    }
    let newValueString = newValue.toFixed(1);
    if (newValueString) {
      newValueString = newValueString.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    newValueString += suffixes[suffixNum];
    return newValueString;
  }

  getRowsCount(){
    return this.libraryIdTabledata.length;
  }

  getValueforLib(field: string, library: any) {
    if (library[field]) {
      return library[field];
    } else {
      return 'N/A';
    }
  }
  sortContainedLibsOnreadDeviationRel(order:number){
    this.containerLibMap.forEach((value:any[],key)=>{
      value.sort((lib1: any, lib2: any) => {
        let libvalue1= this.getRelativeReads(lib1['libraryId'])
        let libvalue2= this.getRelativeReads(lib2['libraryId'])
       return this.getNumericSort(libvalue1, libvalue2)*order;

      });
    })
  }

  customSort(event: any) {
    let compResult = null;
    if (event.field == 'tagInfo') {
      event.data.sort((lib1: any, lib2: any) => {
        let libvalue1 = lib1[event.field][0].tagManufacturerindex + lib1[event.field][0].tagSequence ? lib1[event.field][0].tagManufacturerindex + lib1[event.field][0].tagSequence : null;
        let libvalue2 = lib2[event.field][0].tagManufacturerindex + lib2[event.field][0].tagSequence ? lib2[event.field][0].tagManufacturerindex + lib2[event.field][0].tagSequence : null;
        compResult = this.getSortResult(libvalue1, libvalue2);
        return (event.order * compResult);
      });
    }else if(event.field == 'readDeviationRel' ){
      event.data.sort((lib1: any, lib2: any) => {
        let libvalue1= this.getRelativeReads(lib1['libraryId'])
        let libvalue2= this.getRelativeReads(lib2['libraryId'])
        compResult = this.getNumericSort(libvalue1, libvalue2);
        return (event.order * compResult);
      });
      this.sortContainedLibsOnreadDeviationRel(event.order)
    } else if(event.field == "plateBarcode") {
        event.data.sort((lib1: any, lib2: any) => {
          if(lib1.plateBarcode == 'N/A')
            return (event.order * 1);
          else if(lib2.plateBarcode == 'N/A')
            return (event.order * -1);
          else {
            compResult = this.getSortResult(lib1.plateBarcode, lib2.plateBarcode);
            return (event.order * compResult);
          }
        })
    } else {
      event.data.sort((lib1: any, lib2: any) => {
        let libvalue1 = lib1[event.field] ? lib1[event.field] : '';
        let libvalue2 = lib2[event.field] ? lib2[event.field] : '';
        if(event.field == "libraryId"|| event.field == "libraryType"|| event.field == 'status'||
             event.field == "libraryBarcode"|| event.field == "sampleName" || event.field == "projectName"
             || event.field == "manualRunQCStatus"){
          compResult = libvalue1.localeCompare(libvalue2, undefined, {
            numeric: true,
          })
        }else{
          compResult = this.getNumericSort(libvalue1, libvalue2);
        }
        return (event.order * compResult);
      });
    }
  }
  getNumericSort(value1,value2){
    if(value1 == "" ||value1 == null || value1 == undefined || value1 =='NA'){
      return -1
    }else if(value2 == ""|| value2 == null || value2== undefined || value2 =='NA'){
      return 1
    }
    if (Number(value1) < Number(value2)) {
      return -1;
    }
    return (Number(value1)  > Number(value2) ) ? 1 : 0;

  }

  getSortResult(value1, value2) {
    if(value1 == "" ||value1 == null || value1 == undefined || value1 =='NA'){
      return -1
    }else if(value2 == ""|| value2 == null || value2== undefined || value2 =='NA'){
      return 1
    }
    if (value1 < value2) {
      return -1;
    }
    return (value1 > value2) ? 1 : 0;
  }

  lanePlacement() {
    this.laneBlockMap = new Map();

    let totalReads = 0;
    let totalReadCapacity = 0;

    this.selectedRun.runLanes.forEach((laneData: any) => {

      let laneBlock = new LaneBlock();
      laneBlock.name = PHIX_BLOCK_NAME;
      laneBlock.color = PHIX_COLOR;

      let overDueLaneBlock = new LaneBlock();
      overDueLaneBlock.name = OVERDUE_BLOCK_NAME;
      overDueLaneBlock.color = OVERDUE_COLOR;

      let dueLessLaneBlock = new LaneBlock();
      dueLessLaneBlock.name = DUELESS_BLOCK_NAME;
      dueLessLaneBlock.color = DUELESS_COLOR;

      let dueMoreLaneBlock = new LaneBlock();
      dueMoreLaneBlock.name = DUEMORE_BLOCK_NAME;
      dueMoreLaneBlock.color = DUEMORE_COLOR;

      this.laneBlocks = [];
      if(laneData.runLanes.length > 0){
        let runLaneAtFirstIndex = laneData.runLanes[0];
        laneBlock.weightPercentage = runLaneAtFirstIndex.phiXPercentage;
        totalReads = 0;
        laneData.runLanes.forEach(ipu => {

          totalReads += ipu.weight;
          if (ipu.dueDate < 2) {
            overDueLaneBlock.weight += ipu.weight;
            overDueLaneBlock.ipus.push(ipu);
          } else if (ipu.dueDate >= 2 && ipu.dueDate <= 5) {
            dueLessLaneBlock.weight += ipu.weight;
            dueLessLaneBlock.ipus.push(ipu);
          } else {
            dueMoreLaneBlock.weight += ipu.weight;
            dueMoreLaneBlock.ipus.push(ipu);
          }
        });
        totalReadCapacity = runLaneAtFirstIndex.laneCapacity;
      }
      this.laneBlocks.push(laneBlock);
      this.lanePlacer(overDueLaneBlock, dueLessLaneBlock, dueMoreLaneBlock, totalReadCapacity, laneData);
      this.laneBlockMap.set(laneData.laneId, this.laneBlocks);
    });
  }

  lanePlacer(overDueLaneBlock: any, dueLessLaneBlock: any, dueMoreLaneBlock: any, totalReadCapacity: any, laneData: any) {
    if (overDueLaneBlock.weight > 0) {
      overDueLaneBlock.weightPercentage = Math.round(((overDueLaneBlock.weight / totalReadCapacity) * 100) * 100) / 100;
      this.laneBlocks.push(overDueLaneBlock);
      laneData.occupiedCapacity += overDueLaneBlock.weight;
    }
    if (dueLessLaneBlock.weight > 0) {
      dueLessLaneBlock.weightPercentage = Math.round(((dueLessLaneBlock.weight / totalReadCapacity) * 100) * 100) / 100;
      this.laneBlocks.push(dueLessLaneBlock);
      laneData.occupiedCapacity += dueLessLaneBlock.weight;
    }
    if (dueMoreLaneBlock.weight > 0) {
      dueMoreLaneBlock.weightPercentage = Math.round(((dueMoreLaneBlock.weight / totalReadCapacity) * 100) * 100) / 100;
      this.laneBlocks.push(dueMoreLaneBlock);
      laneData.occupiedCapacity += dueMoreLaneBlock.weight;
    }
  }

  getLaneBlockStyle(laneBlock: LaneBlock) {
    return {
      'width': laneBlock.weightPercentage + '%',
      'background-color': laneBlock.color,
      'border': (laneBlock.weightPercentage > 0) ? '0px solid black' : 'none',
      'height':'3rem'
    }
  }
  getLaneBlocks(laneId: any) {
    return this.laneBlockMap.get(laneId);
  }

  disablePrepareDataForAnalysis() {
    return !this.selectedRun || this.PRIMARY_ANALYSIS_START_STATES.includes(this.selectedRun?.status);
  }

  saveComment()
  {
    this.newComment.commentDate = new Date();
    this.newComment.userComment = this.newComment.userComment.trim();
    this.newComment.puid=this.puid
    this.blocked = true;
    this.runplanProcessService.saveComment(this.selectedRun.runId, this.selectedLabId ,this.newComment).subscribe(
      result => {
        this.blocked = false;
        this.selectedRun = result.data;
        this.comments = this.selectedRun.comments;
        this.previewComment = this.getPreviewComment();
        this.newComment =new Comment()

        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Comment Saved', detail: 'Comment saved successfully' });
      },
      error=>
      {
        this.handleError(error);
      }
      )

  }

  disableAddCommentButton():boolean {
    return !(this.newComment.userComment && this.newComment.userComment.trim() != '')
  }

  clearComment(){
    this.newComment = new Comment();
  }

  onRowExpand(event) {
    if(this.expandedLane) {
      this.laneSelectionMap.set(this.expandedLane, this.clone(this.librarySelectionList));
    }
    this.expandedLane = event.data.laneId;
    if(event.data){
      this.laneLibFilterValue = '';
      this.loading = false;
      this.libraryIdTabledata = this.laneViewMap.get(event.data.laneId);
      this.librarySelectionList = this.clone(this.laneSelectionMap.get(event.data.laneId));
      this.laneSelectionMap.delete(event.data.laneId);
    }
  }

  onRowClose(event: any) {
    this.expandedLane = null;
    this.laneSelectionMap.set(event.data.laneId, this.clone(this.librarySelectionList));
  }

  globalfilterLibrayTable(value: string, lane: any) {
    if (value) {
      this.libraryIdTabledata = this.globalFilter(this.laneViewMap.get(lane["laneId"]), value)
    } else {
      this.libraryIdTabledata = this.laneViewMap.get(lane["laneId"]);
    }
  }

  globalFilter(itemList: any, searchKeyword: string) {
  let filteredList = [];
  if (itemList.length > 0) {
    searchKeyword = searchKeyword.toLowerCase();
    itemList.forEach(item => {
      let propValueList = Object.values(item); // get list of all values from item
      this.getFilteredListFromLoop(propValueList, item, searchKeyword, filteredList);
    });
  }
  return filteredList;
}

  getFilteredListFromLoop(propValueList, item, searchKeyword, filteredList){
    if (item.dueDate && this.getCheckForOtherData(this.getDate(item.dueDate),searchKeyword)) {
      filteredList.push(item);
      return filteredList;
    }
    if(item.missingReads){
        let missingReads = this.abbreviateNumber(item.missingReads);
        if (this.getCheckForOtherData(missingReads,searchKeyword)) {
          filteredList.push(item);
          return filteredList;
        }
      }
    if(item.tagInfo && this.checkForTagInfo(item, searchKeyword.replace(/\s/g, ''))){
        filteredList.push(item);
        return filteredList;
    }

    if(item.containedLibs && (item.containedLibs.length > 0) && item.containedLibs.includes(searchKeyword)) {
      filteredList.push(item);
      return filteredList;
    }

    for (let probVal of propValueList) { // [libraryId, dueDate, missingReads, sampleName, project, status, tag]
      if (this.getCheckForOtherData(probVal,searchKeyword)) {
        filteredList.push(item);
        break;
      }
    }
  }
  checkForTagInfo(item: any, searchKeyword: any) {
    return this.getCheckForOtherData(item.tagInfo[0].tagManufacturerindex, searchKeyword) || this.getCheckForOtherData(item.tagInfo[0].tagSequence, searchKeyword) ||
        this.getCheckForOtherData(item.tagInfo[0].tagManufacturerindex+item.tagInfo[0].tagSequence, searchKeyword);
  }

  getDate(date: any) {
    if(date) {
      return this.datepipe.transform(date, this.selectableLab.lab.dateFormat);
    }
    return null;
  }
  getCheckForOtherData(probVal :any,searchKeyword:any){
    return (probVal && probVal.toString().toLowerCase().indexOf(searchKeyword) > -1);
  }

  isLibraryContainer(library: any) {
    return (library && this.containerLibMap.has(library["libraryId"]))
  }

  getContainerLibraries(containerLib: string) {
    return this.containerLibMap.has(containerLib) ? this.containerLibMap.get(containerLib) : [];
  }

  getTotalLibsCount(lane: any) {
    if(this.laneViewMap.has(lane["laneId"])) {
      let normalSize = this.laneViewMap.get(lane["laneId"]).length;
      for(let containerLib of this.laneContainerLibIdMap.get(lane["laneId"])) {
        normalSize = normalSize + this.containerLibMap.get(containerLib).length - 1;
      }
      return normalSize;
    }
    return 0;
  }

  getSelectLibCount() {
    if(!this.librarySelectionList || this.librarySelectionList.length == 0) {
      return 0;
    }

    let normalLength = this.librarySelectionList.length;
    for(let lib of this.librarySelectionList) {
      if(lib["containedLibs"] && (lib["containedLibs"].length > 0)) {
        normalLength = normalLength + this.containerLibMap.get(lib["libraryId"]).length - 1;
      }
    }

    return normalLength;
  }

  getSelectLibCountForLane(laneId: string) {
    let selectedLibs = (this.laneSelectionMap.has(laneId) && this.laneSelectionMap.get(laneId)) ? this.laneSelectionMap.get(laneId) : [];
    let normalLength = selectedLibs.length;
    for(let lib of selectedLibs) {
      if(lib["containedLibs"] && (lib["containedLibs"].length > 0)) {
        normalLength = normalLength + this.containerLibMap.get(lib["libraryId"]).length - 1;
      }
    }
    return normalLength
  }

  showRemovalSideBar() {
    this.removelErrorReutrnMessage = null;
    this.removalEmptyLibsMessage = null;

    if(!this.libraryActionAllowedStatuses.includes(this.selectedRun.status)) {
      this.removalEmptyLibsMessage = "Removing libs allowed only for Run statuses: RUN_SCHEDULED, RUN_PLANNED, DP_STARTED.";
      this.showRemoveLibsSideBar = true;
      return;
    }
    this.userEmail = null;
    this.userPassword = null;
    if(this.expandedLane) {
      this.laneSelectionMap.set(this.expandedLane, this.librarySelectionList);
    }

    this.removalLibraryObjects = [];
    this.removalLibraryIds = [];
    this.removalContainedLibIds = [];
    this.libraryCount = 0;
    this.libraryReadsRemovalMap = {};
    let unselectableLibs = [];
    this.laneSelectionMap.forEach((value: any[], key: string) => {
      if(this.selectedRun.status == DP_STARTED && this.isLaneHamiltonGenerated(key)) {
        unselectableLibs.push(value.map(lib => lib.libraryId));
      } else {
        value.forEach(lib => {
          this.removalLibraryObjects.push({'libraryId' : lib["libraryId"], 'project': lib["projectName"]});
          this.libraryReadsRemovalMap[lib["libraryId"]] = lib['missingReads'];
          this.removalLibraryIds.push(lib["libraryId"]);
          if(lib['containedLibs'] && lib['containedLibs'].length > 0) {
            this.removalContainedLibIds = this.removalContainedLibIds.concat(lib['containedLibs']);
          }
        });
      }
      this.libraryCount += value.length;
    });

    if(unselectableLibs.length > 0) {
      this._messagesService.addErrorMessage({severity: 'error', summary: 'Libraries cannot be removed',
        detail: 'Following libs cannot be removed as they are on lanes where Dilution and Pooling has started: ' + unselectableLibs.join(', ')});
      return;
    }

    if(this.libraryCount == 0) {
      this.removalEmptyLibsMessage = "There are no libraries to remove. Please select libraries to remove and then click Go.";
    } else {
      this.removalEmptyLibsMessage = null;
    }
    this.showRemoveLibsSideBar = true;
  }

  isLaneHamiltonGenerated(laneId: string) {
    let hamiltonGenerated = false;
    this.laneViewList.forEach((lane: LaneViewDataDTO) => {
      if(laneId == lane.laneId && lane.hamiltonFileGenerated) {
        hamiltonGenerated = true;
      }
    });

    return hamiltonGenerated
  }

  submitRemoval() {
    if(this.isValidMDMRole) {
      this.removelErrorReutrnMessage = null;
    } else {
      this.removelErrorReutrnMessage = 'Current logged user must be an MDM Admin to perform this action!';
      return;
    }
    let runCopy = this.clone(this.selectedRun);
    let comment =  new Comment();
    comment.puid = this.puid;
    comment.commentDate = new Date();
    comment.userComment = "";

    let commentList: string[] = [];

    this.runCopyCreator(runCopy, commentList, comment);

    this.blocked = true;
    this.runplanProcessService.removeLibs(runCopy).subscribe(
      result => {
        this.removelErrorReutrnMessage = null;
        this.removalEmptyLibsMessage = null;
        this.togglePlateView();
        this.selectedRun = result.data;
        this.comments = this.selectedRun.comments;
        this.previewComment = this.getPreviewComment();
        this.showRemoveLibsSideBar = false;
        this.blocked = false;
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this.removelErrorReutrnMessage = message.detail;
      }
    );
  }

  private runCopyCreator(runCopy: RunDetails, commentList: string[], comment: Comment) {
    let gxpLaneFlag = false;
    let gxpRunFlag = false;
    runCopy["runLanes"].forEach(lane => {
      if (lane["runLanes"] && lane["runLanes"].length > 0) {
        let removalWeight = 0;
        lane["runLanes"].forEach(ipu => {
          for(let i = ipu.libraryId.length - 1; i >= 0; i--){

            if(this.removalLibraryIds.includes(ipu.libraryId[i])){
              ipu.weight = ipu.weight - this.libraryReadsRemovalMap[ipu.libraryId[i]];
              removalWeight += this.libraryReadsRemovalMap[ipu.libraryId[i]];
              ipu["libraryId"].splice(i, 1)
            }else{
              gxpLaneFlag = gxpLaneFlag || (this.libLaneGXPMap.has(ipu.libraryId[i]) ? this.libLaneGXPMap.get(ipu.libraryId[i])['gxp']  :false);
              gxpRunFlag = gxpRunFlag || gxpLaneFlag
            }
          };
        });
        let ipuAtLastIndex = lane.runLanes[lane.runLanes.length - 1]
        ipuAtLastIndex.remainingCapacity += removalWeight;
      }
      lane["runLanes"] = lane["runLanes"].filter(ipu => (ipu.libraryId && ipu.libraryId.length > 0));
      lane['gxp'] = gxpLaneFlag;
      gxpLaneFlag = false;
    });
    runCopy['gxp'] = gxpRunFlag;
    runCopy["runLanes"] = runCopy["runLanes"].filter(lane => (lane["runLanes"] && lane["runLanes"].length > 0));

    if (runCopy["runLanes"] && runCopy["runLanes"].length > 0) {
      this.laneSelectionMap.forEach((value: any[], key: string) => {
        if (value.length > 0) {
          if (this.laneViewMap.get(key).length == value.length) {
            commentList.push(key + " has been removed\n");
          } else {
            commentList.push(key + ": Lib(s) " + this.getLibsString(value) + " have been removed.");
          }
        }
      });
      commentList.sort();
      comment.userComment = "Run has been modified as follows:\n";
      commentList.forEach(cmnt => {
        comment.userComment += cmnt + "\n";
      });
    } else {
      comment.userComment = "Run has been removed";
      runCopy.status = "CANCELLED";
    }

    runCopy.removedLibraries = this.removalLibraryIds.concat(this.removalContainedLibIds);
    if (runCopy.comments && runCopy.comments.length > 0) {
      runCopy.comments.push(comment);
    } else {
      runCopy.comments = [comment];
    }
  }

  getLibsString(libs: any[]) {
    let cmntString = libs[0]['libraryId'];
    for(let i = 1; i < libs.length; i++) {
      cmntString +=  ", " + libs[i]['libraryId'];
    }
    return cmntString;
  }

  showRunCompletionSidebar(){
    this.sequencingRunContinuationValue = 'complete';
    this.processViewSidebar = true;
    this.userEmail = '';
    this.userPassword = '';
  }

  submitRunDecisionOnSequencingCompleted(){
    if(this.sequencingRunContinuationValue === 'complete' || this.sequencingRunContinuationValue === 'abort with no copy'){
      if(this.showRunConfirmation){
        this.handleRunQCPassedSelection();
      }else{
        this.seqRunFinished('SEQ_RUN_FINISHED')
      }
    } else{
      if(!this.isValidMDMRole){
        this._messagesService.addErrorMessage({severity: 'error', summary:'Invalid Action!', detail:'Current logged user must be an MDM Admin to perform this action!'});
        return;
      }

      this.selectedRun.sequencingRunFinishedDateTime = new Date();
      this.selectedRun.sequencingRunFinishedPUID = this.puid;

      this.blocked = true;
      let reqObj = this.clone(this.selectedRun);
      reqObj["redoRunStatus"] = this.showRunConfirmation ? "REDO" :"CANCELLED";
      reqObj["labName"] = this.selectableLab.lab.name
      this.runplanProcessService.redoRun(reqObj).subscribe(
        result=>{
          this.showRunConfirmation = false
          this.selectedRun = result.data;
          this.comments = this.selectedRun.comments;
          this.previewComment = this.getPreviewComment();
          this.processViewSidebar = false;
          this._messagesService.addSuccessMessage({severity:'success', summary:'Run has been cancelled!', detail:`Redo is successful & Run status has been changed to ${this.selectedRun.status}.`});
          this.blocked = false;
        }, error=>{
          this.handleError(error);
        }
      )
    }
  }

  private handleRunQCPassedSelection() {
    if(this.checkForONTRun()) {
      this.updateManualRunQCStatusForONTRun();
    } else {
      this.createRunQCReviewStatusForMint(this.selectedLaneIdForCompleteRun)
    }
    this.showRunConfirmation = false
  }

  convertStringToUTF8ByteArray(str) {
    let data = [];
    for (let i = 0; i < str.length; i++) {
      data.push(str.charCodeAt(i));
    }
    return data;
  }

  isRunActionDisabled() {
    return (!this.runActionSelection);
  }

  closeRemovalSideBar() {
    this.showRemoveLibsSideBar = false;
  }

  isSubmitDisabled() {
    return !(this.validateEmailID(this.userEmail) && this.userPassword && (this.userPassword.length > 0));
  }

  validateEmailID(emailID: string) {
    if(emailID) {
      const emailRegex = /^([a-zA-Z0-9]{4})@[a-zA-Z0-9.]*\.com$/;
      const matches = emailID.match(emailRegex);
      return matches;
    } else {
      return false;
    }
  }

  getUserIdFromEmail(emailID: string) {
    let value = this.validateEmailID(emailID);
    return value[1];
  }

  actionSelectionAllowed() {
    return this.libraryActionAllowedStatuses.includes(this.selectedRun.status);
  }

  getContainedRowStyle(containedLib: any) {
    let containerLib = containedLib["containerLib"];
    if(this.librarySelectionList.findIndex(lib => lib["libraryId"] == containerLib) != -1) {
      return {
        'background-color' : '#007AD9',
        'color' : 'white'
      }
    } else {
      return {
        'color' : '#0e56f0'
      }
    }
  }
  clearAllSelectionBoolean(){
    this.librayAllSelectMap[this.expandedLane] = false;
    this.laneLibSelctedMap.set(this.expandedLane ,this.librarySelectionList);
  }
  mergePooledLib(libraryId){
   if(this.containerLibMap.has(libraryId)){
    this.librarySelectionList = [...this.librarySelectionList ,... this.containerLibMap.get(libraryId)];
    }
  }

  onAllLibSelection(checked){
    if(checked){
      if (this.disablePooledRowSelection()){
        this.librarySelectionList = [...this.libraryIdTabledata]
      }else{
        this.libraryIdTabledata.forEach(library=>{
        if(library['containedLibs'] && library['containedLibs'].length>0 ){
          this.mergePooledLib(library['libraryId']);
        }else{
          this.librarySelectionList =[...this.librarySelectionList,library]
        }
      })
      }
    }else{
      this.librarySelectionList = []
    }
    this.laneLibSelctedMap.set(this.expandedLane,this.librarySelectionList)

   }

  getRelativeReads(libId: string) {
    if(this.libraryQCMap[libId]) {
      return this.roundOff(this.libraryQCMap[libId]['readDeviationRel'])
    } else {
      return "N/A";
    }
  }

  getLibReadsString(library: any) {
    let libId = library['libraryId'];
    let plannedReads = "N/A";
    let mappedReads = "N/A";
    if(this.libraryQCMap[libId]) {
      plannedReads = this.convertNumber(this.libraryQCMap[libId]['plannedReads']);
      mappedReads = this.convertNumber(this.libraryQCMap[libId]['mappedReads']);
    }
    return "Planned: " + plannedReads + '\n' + "Mapped: " + mappedReads + '\n';
  }

  generateUnkownTagCSV(runId:string, laneId:string){
    this.blocked = true;
    let laneNo = laneId.substring(laneId.lastIndexOf(" ")+1)
    let fileCsv: string = this.datepipe.transform(new Date(), 'yyyyMMdd_HHmmss')+"_ID"+runId+"_"+laneNo+'_Top20Unknowns.csv';
    this.runplanProcessService.getUnKownTagCSV(this.selectedLabId, laneId, runId).subscribe(
      result => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({
          severity:'success', summary:'Initiating File Download!', detail:''
        });
        let blobData: Blob = new Blob([result.data], { type: 'text/plain' });
        saveByFileSaver(blobData, fileCsv);
      },
      error => {
        this.blocked = false;
        this.handleError(error);
      }
    );
  }

  isUnknownTagsButtonActive(unknownTags: Map<string, any>) {
    return !unknownTags || !unknownTags.size;
  }

  disableDilutionAndPoolingStarted() {
    return (this.selectedRun?.status != RUN_SCHEDULED);
  }

  saveRunForDnP() {
    this.blocked = true;
    this.runplanProcessService.updateRunStatus(this.selectedRun).subscribe(
      results=>{
        this.selectedRun = results.data;
        this.togglePlateView();
        this.blocked = false;
      }, error => {
        this.handleError(error);
        this.blocked = false;
      }
    )
  }

  finalConcSaveDisabled(lane: LaneViewDataDTO) {
    return (lane.totalLibIds == 0 || lane.userInputFinalConc == null || lane.userInputFinalConc == undefined || lane.statusOfTheLane == DP_STARTED || lane.hamiltonFileGenerated);
  }

  finalConcInputSaveDisabled(lane: LaneViewDataDTO) {
    return (lane.totalLibIds == 0 || lane.statusOfTheLane == DP_STARTED || lane.hamiltonFileGenerated);
  }

  getUploadStyle() {
    return {
      'font-weight': 'bold',
      'font-size': '14px',
      'width': '100%',
      'border-radius': '5px',
      'height': '2rem',
      'padding':'0'
    }
  }

  onLogUpload(event: any, fileUploader: any, lane: LaneViewDataDTO) {
    this.currentBusyLane = lane.laneId;
    let libraryBarocdes = [];
    for(let library of this.laneViewMap.get(this.currentBusyLane)) {
      libraryBarocdes.push(library.libraryBarcode);
    }

    let jsonObj = {};
    jsonObj['labId'] = this.selectedLabId;
    jsonObj['runId'] = this.selectedRun.runId;
    jsonObj['laneId'] = lane.laneId;
    jsonObj['libraries'] = libraryBarocdes;
    jsonObj['poolingRun'] = lane.poolingRun;
    jsonObj['puid'] = this.puid;
    jsonObj['labName'] = this.selectableLab.lab.name

    let file = event.files[0];

    let formData = new FormData();
    formData.append('file', file);
    formData.append('uploadType', this.getHamiltonLogFileUploadType(file?.name));
    formData.append('requestData', JSON.stringify(jsonObj));

    this.runplanProcessService.uploadHamiltonLogFile(formData).subscribe(
      results => {
        fileUploader.clear();
        this.currentBusyLane = '';
        if(results.data.error) {
          this.displayLogFileUploadError(results.data);
        } else {
          lane.poolingRun += 1;
          lane.eppiPosition = results.data.eppiPosition;
          lane.dnPfiles.push(file.name);
          lane.plateBarcodesForPoolingRun = results.data.plateBarcodes ?? []
          this.updatePoolingRunInLane(lane.laneId, results.data.eppiPosition, file.name, results.data.plateBarcodes);
          this.updatePoolingRunForLibs(lane.laneId, results.data.barcodes);
          this._messagesService.addSuccessMessage({ severity:'success', summary:'Log file uploaded successfully!', detail: 'Current pooling run is: ' + lane.poolingRun});
        }
      },
      error => {
        this.currentBusyLane = '';
        fileUploader.clear();
        this.handleError(error);
      }
    )
  }

  getHamiltonLogFileUploadType(fileName: string): string {
    return fileName?.endsWith(".log") ? "dnp_log_file" : "dnp_txt_file"
  }

  updatePoolingRunForLibs(laneId: string, barcodeList: string[]) {
      let librariesInLane = this.laneViewMap.get(laneId);
      for(let lib of librariesInLane) {
        if(barcodeList?.includes(lib.libraryBarcode)) {
          lib.poolingRun = lib.poolingRun ? lib.poolingRun + 1 : 1;
        }
      }
      this.laneViewMap.set(laneId, librariesInLane);
  }

  displayLogFileUploadError(errorLog: any) {
    this.logFileErrorMessage = '';
    if(errorLog['runAndLane'] && errorLog['runAndLane'] != '') {
      this.logFileErrorMessage = '<div>' + errorLog['runAndLane'] + '</div>';
    }

    if(errorLog['libraryOutOfLane'] && errorLog['libraryOutOfLane'].length > 0) {
      this.logFileErrorMessage += '<div class=\"mt-2\">The following libraries in the file where not found in the lane: <br><b>' + errorLog['libraryOutOfLane'] + '</b></div>';
    }

    if(errorLog['libraryReadiness'] && errorLog['libraryReadiness'].length > 0) {
      this.logFileErrorMessage += '<div class=\"mt-2\">The following libraries in the file where not in status DP_READY: <br><b>' + errorLog['libraryReadiness'] + '</b></div>';
    }
    if(errorLog['duplicateBarcodes'] && errorLog['duplicateBarcodes'].length > 0) {
      this.logFileErrorMessage += '<div class=\"mt-2\">The following libraries in the Log file are duplicate : <br><b>' + errorLog['duplicateBarcodes'] + '</b></div>';
    }

    if(errorLog['plateBarcode']) {
      this.logFileErrorMessage += '<div>' + errorLog['plateBarcode'] + '</div>';
    }
    this.showLogFileUploadError = true;
  }

  updatePoolingRunInLane(laneId: string, eppiPosition: number, fileName: string, plateBarcodes: string[]) {
    this.selectedRun.runLanes.forEach(lane => {
      if(lane.laneId == laneId) {
        lane.poolingRun += 1;
        lane.eppiPosition = eppiPosition;
        lane.dnPfiles.push(fileName);
        lane.plateBarcodesForPoolingRun = plateBarcodes ?? []
      }
    });
  }

  isStartDnPDisabled(lane: LaneViewDataDTO) {
    return (lane?.totalLibIds == 0 || lane?.statusOfTheLane == DP_STARTED || lane?.statusOfTheLane == DP_COMPLETED);
  }

  saveFinalConcentration(lane: LaneViewDataDTO) {
    this.currentBusyLane = lane['laneId'];

    let libraryBarcodes = [];
    for (let library of this.laneViewMap.get(this.currentBusyLane)) {
      libraryBarcodes.push(library.libraryBarcode);
    }

    let requestBody = {
      'lab': this.selectedLabId,
      'runId': this.selectedRun.runId,
      'laneId': this.currentBusyLane,
      'concentration': lane.userInputFinalConc,
      'libraryIds': libraryBarcodes
    };

    this.runplanProcessService.saveFinalConcentrationForLane(requestBody).subscribe(
      result => {
        this.currentBusyLane = '';
        if (result.data) {
          lane.finalConcentration = lane.userInputFinalConc;
          let libraries = this.laneViewMap.get(lane['laneId']);
          libraries.forEach(lib => {
            lib.concentration = lane.userInputFinalConc;
          })
          this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Final Concentration Updated!', detail: lane['laneId'] + ' updated' });
          this.updateCurrentRunWithConcentration(lane['laneId'], lane.finalConcentration);
        } else {
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'Update failed!', detail: 'Please try again' });
        }
      },
      error => {
        this.currentBusyLane = '';
        this.handleError(error);
      }
    );
  }

  updateCurrentRunWithConcentration(laneId: string, finalConcentration: number) {
    this.selectedRun.runLanes.forEach(lane => {
      if (lane.laneId == laneId) {
        lane.finalConcentration = finalConcentration;
      }
    });
  }

  startDnP(lane: LaneViewDataDTO) {

    let librariesWithoutConcentration = this.laneViewMap.get(lane['laneId'])
      .filter(lib => (lib.concentration == null || lib.concentration == undefined))
      .map(lib => lib.libraryBarcode);

    if(librariesWithoutConcentration.length == this.laneViewMap.get(lane['laneId']).length) {
      this._messagesService.addErrorMessage({severity: 'error', summary: 'Final concentrations not found!',
        detail: 'No final concentrations found in libraries and lane. Please input final concentration to start DnP'});
      return;
    } else if(librariesWithoutConcentration.length > 0) {
      this._messagesService.addErrorMessage({severity: 'error', summary: 'Final concentration missing in libraries!',
        detail: 'Final concentration not found for the following libraries: ' + librariesWithoutConcentration.join(', ')});
      return;
    }

    this.printPoolLabel(lane['laneId']);

    this.currentBusyLane = lane['laneId'];
    let libraryIds = [];
    let molarityMissingList = [];
    for (let library of this.laneViewMap.get(this.currentBusyLane)) {
      if (library.molarity == null || library.molarity == undefined || isNaN(library.molarity)) {
        molarityMissingList.push(library.libraryId);
      }
      libraryIds.push(library.libraryId);
    }

    if (molarityMissingList.length > 0) {
      this.currentBusyLane = '';
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Molarity missing', detail: 'Libraries ' + molarityMissingList + ' are missing molarity. Please update molarities before proceeding with D&P.' });
      return;
    }

    let requestBody = {
      'lab': this.selectedLabId,
      'runId': this.selectedRun.runId,
      'laneId': this.currentBusyLane,
      'concentration': lane.finalConcentration,
      'libraryIds': libraryIds,
      'puid': this.puid
    }

    this.runplanProcessService.startDnP(requestBody).subscribe(
      result => {
        this.currentBusyLane = '';
        lane.statusOfTheLane = DP_STARTED;
        if (result.data) {
          this.laneDPWaitingMap.set(lane['laneId'], true);
          this.updateLibrariesInMapForDnP(lane, result.data);
          this.updateLaneStatusForDnP(lane['laneId'], DP_STARTED);
        }
        this._messagesService.addSuccessMessage({severity:'success', summary: 'Dilution and Pooling Started', detail: 'For current lane'});
      },
      error => {
        this.currentBusyLane = '';
        this.handleError(error);
      }
    );
  }

  updateLaneStatusForDnP(laneId: string, status: string) {
    this.selectedRun.runLanes.forEach(lane => {
      if (lane.laneId == laneId) {
        lane.statusOfTheLane = status;
      }
    });
  }

  updateLibrariesInMapForDnP(lane: any, libraryDPObj: any) {
    let librariesInLane = this.laneViewMap.get(lane['laneId']);
    lane.allLibsDPWaiting = true;
    for (let lib of librariesInLane) {
      if (libraryDPObj[lib['libraryId']]) {
        lib['status'] = libraryDPObj[lib['libraryId']]['status'];
        lib['badTdf'] = libraryDPObj[lib['libraryId']]['badTdf'];

        if(lib['status'] != DP_WAITING) {
          lane.allLibsDPWaiting = false;
        }
      }
    }
    this.laneViewMap.set(lane['laneId'], librariesInLane);
  }

  getStyleForOuterTableRow(library: any) {
    if (library?.status == DP_WAITING) {
      return this.dpWaitingRowStyle;
    }
  }

  getStyleForLane(lane: LaneViewDataDTO) {
    if (lane?.statusOfTheLane == DP_STARTED) {
      return this.dpStartedLaneStyle;
    } else {
      return this.nonDPLaneStyle;
    }
  }

  serviceCallForPrinterList() {
    this.printerList = [];
    this.printPlateLabelService.getPrintersList(this.selectableLab.lab, true).subscribe(
      results => {
        if (!results) {
          return;
        }
        for (let result of results.data) {
          if (result.template) {
            if ('Tube' == result.template.entity) {
              this.printerList.push({ label: result.name, value: result});
            }
          }
        }
      },
      error => {
        this.handleError(error);
      });
  }

  printPoolId(laneId: string, formatStringOriginal: string) {
    let directPrintRequest = new DirectPrintRequest();
    directPrintRequest.printer = this.selectedPrinter
    directPrintRequest.directPrintCommands = [];
    let poolId = this.selectedRun.runId + '_' + laneId.replace(/\D/g, "")
    formatStringOriginal = this.printTemplateUtil.replaceToken(formatStringOriginal, '#' + this.printTemplateUtil.BARCODE_TOKEN + '_1#', poolId);
    formatStringOriginal = this.printTemplateUtil.replaceToken(formatStringOriginal, '#' + this.printTemplateUtil.PROJECT_TOKEN + '_1#', null);
    formatStringOriginal = this.printTemplateUtil.replaceToken(formatStringOriginal, '#' + this.printTemplateUtil.SAMPLE_NAME_TOKEN + '_1#', null);
    formatStringOriginal = this.printTemplateUtil.replaceToken(formatStringOriginal, '#' + this.printTemplateUtil.SHORTCODE_TOKEN + '_1#', null);
    formatStringOriginal = this.printTemplateUtil.replaceToken(formatStringOriginal, '#' + this.printTemplateUtil.LIBRARY_ID_TOKEN + '_1#', null);
    formatStringOriginal = this.printTemplateUtil.replaceToken(formatStringOriginal, '#' + this.printTemplateUtil.LIBRARY_TYPE_TOKEN + '_1#', null);
    directPrintRequest.directPrintCommands.push(formatStringOriginal);

    this.runplanProcessService.printSampleLabels(directPrintRequest).subscribe(
      result => {
        if(result.data) {
          this._messagesService.addSuccessMessage({severity: 'success', summary: result.data});
        }
      },
      error => {
        this.handleError(error);
      }
    );
  }

  closeLogFileUploadErrorDialog() {
    this.showLogFileUploadError = false;
  }

  disablePooledRowSelection() {
    return this.POOL_DISABLED_STATES.has(this.selectedRun.status)
  }

  disableContainerLibSelection(library) {
    return (library['containedLibs'] && library['containedLibs'].length > 0 && !this.disablePooledRowSelection())
  }

  disableUpload(lane: LaneViewDataDTO) {
    return (lane?.statusOfTheLane != DP_STARTED);
  }

  getRunIdStatusList() {
    let reqObj = {}
    let toDate;
    if (this.toDate) {
      toDate = this.clone(this.toDate)
      toDate.setDate(this.toDate.getDate() + 1)
    }
    reqObj['lab'] = this.selectedLabId;
    reqObj['fromDate'] = this.datepipe.transform(this.fromDate, "yyyy-MM-dd");
    reqObj['toDate'] = this.datepipe.transform(toDate, "yyyy-MM-dd");
    reqObj['selectdstatus'] = this.selectedStates;
    let finalStusFlag = this.selectedStates.some(state => this.FINAL_STATUSES.has(state.toString()))


    if (!reqObj['fromDate'] && !reqObj['toDate'] && finalStusFlag) {
      let fromDate = new Date()
      fromDate.setDate(fromDate.getDate() - 14)
      toDate = new Date()
      toDate.setDate(toDate.getDate()+1)
      reqObj['toDate'] = this.datepipe.transform(toDate, "yyyy-MM-dd")
      reqObj['fromDate'] = this.datepipe.transform(fromDate, "yyyy-MM-dd")
      this.fromDate = fromDate;
      this.toDate = new Date();
    }

    if (this.selectedStates.length == 0) {
      reqObj['selectdstatus'] = this.NON_FINAL_STATUSES
    }
    this.getRunIdStatusListServiceCall(reqObj);
  }

  getRunIdStatusListServiceCall(reqObj: any) {
    this.blocked = true;
    this.runplanProcessService.getFilterdStatusList(reqObj).subscribe(
      result => {
        this.blocked = false;
        this.runStatusList = []
        if (result.data) {
          this.runStatusList = result.data;
        }

      }, error => {
        this.blocked = false;
        this.handleError(error);
      }
    );
  }

  batchViewVisbility(event) {
    this.valueToSearch = event.data.runId;
    this.searchForRunWIthFilter();
  }

  hamiltonFileDownloadDisabled(lane: LaneViewDataDTO) {
    return !(lane.statusOfTheLane == DP_STARTED && lane.poolingRun > 0)
  }

  downloadHamiltonWorkfile(lane: LaneViewDataDTO) {

    this.currentBusyLane = lane.laneId;

    let libraryBarocdes = [];
    for(let library of this.laneViewMap.get(this.currentBusyLane)) {
      libraryBarocdes.push(library.libraryBarcode);
    }

    let requestBody = {
      'labId': this.selectedLabId,
      'runId': this.selectedRun.runId,
      'laneId': this.currentBusyLane,
      'barcodes': libraryBarocdes,
      'poolingRun': lane.poolingRun,
      'laneEppiPosition': lane.eppiPosition,
      'finalConcentration': lane.finalConcentration,
      'puid': this.puid,
      'hamiltonFileWithPlateBarcodes': lane.plateBarcodesForPoolingRun?.length != 0,
      'plateBarcodes': lane.plateBarcodesForPoolingRun,
      'labName': this.selectableLab.lab.name
    };

    let laneId = this.clone(this.currentBusyLane).replace(/\D/g, "");
    let fileName = "DP_Workfile_" + this.selectedRun.runId + "_" + laneId +"_" + lane.poolingRun + ".csv";

    this.runplanProcessService.downloadDilutionAndPoolingWorkfile(requestBody).subscribe(
      result => {
        this.currentBusyLane = '';
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Intiating File download',
          detail: '',
        });

        var blob = new Blob([result.fileContent], { type: 'application/octet-stream' });
        saveByFileSaver(blob, fileName);
        this.updateLaneWithFileName(lane, fileName);
        this.updateLibrariesInCurrentPoolingRun(lane.laneId, lane.poolingRun);
      },
      error => {
        this.currentBusyLane = '';
        this.handleError(error);
      }
    );
  }

  updateLibrariesInCurrentPoolingRun(laneId: string, poolingRun: number) {
    let librariesInLane = this.laneViewMap.get(laneId);
    for(let lib of librariesInLane) {
      if(lib.poolingRun == poolingRun) {
        lib['status'] = DP_COMPLETED;
      }
    }
    this.laneViewMap.set(laneId, librariesInLane);
  }

  updateLaneWithFileName(lane: LaneViewDataDTO, filename: string) {

    lane.dnPfiles.push(filename);
    lane.hamiltonFileGenerated = true;
    this.selectedRun.runLanes.forEach(laneFromRun => {
      if(laneFromRun.laneId == lane.laneId) {
        laneFromRun.dnPfiles.push(filename);
        laneFromRun.hamiltonFileGenerated = true;
      }
    });

    let requestObj = {
      'fileName': filename,
      'labId': this.selectedLabId,
      'batchId': this.selectedRun.runId
    };

    this.runplanProcessService.saveToWorkfiles(requestObj).subscribe(
      _result => {},
      error => {
        this.handleError(error);
      }
    );
  }

  downloadDnPFile(fileName: string, laneId: string) {
    this.currentBusyLane = laneId;
    const dataToUpload = { "fileName": fileName, "labName": this.selectableLab.lab.name };
    let jsonDataString: string = JSON.stringify(dataToUpload);

    this.runplanProcessService.downloadSampleSheet(this.DNP_DOWNLOAD_TYPE, jsonDataString).subscribe(
      result => {
        this.currentBusyLane = '';
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Intiating File download',
          detail: '',
        });
        var blob = new Blob([result.fileContent], { type: 'application/octet-stream' });
        saveByFileSaver(blob, fileName);
      },
      _error => {
        this.currentBusyLane = '';
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'File Not Found', detail: 'File not present on blob ' + fileName });
      }
    );
  }

  updateQCStatus(laneId: string) {
    let reqObj = {}
    reqObj['labId'] = this.selectedLabId;
    reqObj['runId'] = this.selectedRun.runId;
    reqObj['laneId'] = laneId;
    reqObj['libraryIds'] = this.laneLibSelctedMap.get(laneId).map(lib => lib.libraryId)
    reqObj['status'] = this.selectedQCStatus;
    this.blocked = true;
    this.runplanProcessService.updateQCstatus(reqObj).subscribe(
      _result => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Qc Status Updated Successfully!' })
        this.laneLibSelctedMap.get(laneId).forEach(lib => lib['manualRunQCStatus'] = this.selectedQCStatus)
        this.validateAndSetQCStatusMap(laneId)
        this.selectedQCStatus = null;
        this.librarySelectionList = [];
      },
      error => {
        this.blocked = false;
        let errorMessage = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(errorMessage);
      }
    )

  }

  disableSaveBtn(laneData){
    return (!this.selectedQCStatus || (laneData['statusOfTheLane'] === MANUAL_RUNQC_FINISHED))
    || (this.checkForONTRun() && this.DISABLE_ION_SEQUENCER_COMPLETE_RUNQC_REVIEW_FOR_STATUS.has(this.selectedRun.status));
  }

  setQCFailedStatus(laneId,status){
    if(status == 'QC Passed' || status == null || status == undefined){
      this.laneQcStatusMap.get(laneId)['allQcFailed'] = false;
    }
  }

  setLaneQCStatusMap(laneId, statusOftheLane) {
    this.laneQcStatusMap.set(laneId, {'completeRunBtnDisable':false ,'allQcFailed':true,'status':statusOftheLane})

    if(statusOftheLane == "MANUAL_RUNQC_FINISHED"){
      this.laneQcStatusMap.set(laneId, {'completeRunBtnDisable':true ,'allQcFailed':true,'status':statusOftheLane})
      for (let lib of this.laneViewMap.get(laneId)){
        if(lib['manualRunQCStatus']=='QC Passed'){
          this.laneQcStatusMap.get(laneId)['allQcFailed'] = false;
        }
      }
    }else{
      this.validateAndSetQCStatusMap(laneId)
   }
  }

  validateAndSetQCStatusMap(laneId) {
    this.laneQcStatusMap.get(laneId)['completeRunBtnDisable'] = false
    this.laneQcStatusMap.get(laneId)['allQcFailed'] = true

    if (this.laneViewMap.has(laneId)) {
      for (let lib of this.laneViewMap.get(laneId)) {
        if (this.POOL_DISABLED_STATES.has(this.selectedRun.status) && !lib['manualRunQCStatus']) {
          this.laneQcStatusMap.get(laneId)['completeRunBtnDisable'] = true;
          this.setQCFailedStatus(laneId, lib['manualRunQCStatus'])
          break
        }

        else {
          if(!lib['containedLibs']){
            this.setQCFailedStatus(laneId, lib['manualRunQCStatus'])
          }
          if (!lib['containedLibs'] && !lib['manualRunQCStatus']) {
            this.laneQcStatusMap.get(laneId)['completeRunBtnDisable'] = true;
            break;

          } if (lib['containedLibs'] && this.containerLibMap.has(lib['libraryId'])) {
            for (let containedLib of this.containerLibMap.get(lib['libraryId'])) {

              this.setQCFailedStatus(laneId, containedLib['manualRunQCStatus'])

              if (!containedLib['manualRunQCStatus']) {
                this.laneQcStatusMap.get(laneId)['completeRunBtnDisable'] = true;
                break;
              }
            }
          }
        }
      }
    }
  }

  disableCompleteRunQC(laneId: string) {
    return (this.laneQcStatusMap.get(laneId)['completeRunBtnDisable'] || this.selectedRun.status === "REDO" || !this.laneViewMap.has(laneId))
    || (this.checkForONTRun() && this.DISABLE_ION_SEQUENCER_COMPLETE_RUNQC_REVIEW_FOR_STATUS.has(this.selectedRun.status));
  }

  getRunQCStatusObj(laneNo, lib, runId, allLib) {
    allLib.push(lib.libraryId)
    //message structure sent to MINT
    return {
      'reportVersion' : lib.reportVersion,
      'libraryBarcode': lib.libraryBarcode,
      'run': runId,
      'labName' : this.selectableLab.lab.name,
      'containerLibraryBarcode': null,
      'runQCStatus': lib['manualRunQCStatus'],
      'lane': Number(laneNo),
      'sequencerType' : this.selectedRun.sequencerType
    }

  }

  async sendQCStatusToMINT(reqObj) {
    this.blocked = true;
    this.runplanProcessService.sendRunQCStatusToMint(reqObj).subscribe(
      async result => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'RunQc Review Status Sent Successfully!' })

        if( reqObj['updaterunFlag']){
          this.selectedRun.status=="COMPLETED"
        }
        this.valueToSearch = this.selectedRun.runId;
        await this.searchForRunWIthFilter();
        if(!this.checkForONTRun()) {
          await this.togglePlateView();
        }
         this.laneQcStatusMap.get(reqObj['laneId'])['completeRunBtnDisable'] = true
         this.laneQcStatusMap.get(reqObj['laneId'])['status'] = "MANUAL_RUNQC_FINISHED"
      },
      error => {
        this.blocked = false;
        let errorMessage = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(errorMessage);
      }
    )
  }

  getCountOfnotCompleteRunQCFlag():number{
    let notCompleteRunQCFlag = 0
    this.laneQcStatusMap.forEach((value,key)=>{
      if(value['status'] != "MANUAL_RUNQC_FINISHED"){
        notCompleteRunQCFlag+=1
      }}
      )
      return notCompleteRunQCFlag ;
  }

  getQcFailedCompleteRunQCFlag():boolean{
    let notCompleteRunQCFlag = 0
    let redoFlag = true;
    this.laneQcStatusMap.forEach((value,key)=>{
      if(!value['allQcFailed']){
        redoFlag = false;
      }
      if(!value['completeRunBtnDisable']){
        notCompleteRunQCFlag+=1
      }})
      if(notCompleteRunQCFlag >1 ){
        redoFlag = false;
      }
      return redoFlag;
  }

  showReprintButton(lane: LaneViewDataDTO) {
    return (lane.statusOfTheLane == DP_STARTED || lane.statusOfTheLane == DP_COMPLETED);
  }

  printPoolLabel(laneId: string) {
    if(!this.selectedPrinter) {
      this._messagesService.addErrorMessage({severity:'error', summary: 'No Printer selected', detail: 'Please select a printer to print pool ID'});
      return;
    }

    if(!this.selectedPrinter.template
      || !this.selectedPrinter.template.format
      || this.selectedPrinter.template.format.trim() == '') {
      this._messagesService.addErrorMessage({severity: 'error', summary: 'Invalid printer template',
        detail: 'Printer template format string appears to be empty. Please fill in the ' +
        'command string in template and reassign it to the printer to continue.'});
      return;
    }

    let formatStringOriginal = this.selectedPrinter.template.format;
    if(!this.printTemplateUtil.doesTemplateHaveToken(formatStringOriginal, this.printTemplateUtil.BARCODE_TOKEN)) {
      this._messagesService.addErrorMessage({severity: 'error', summary: 'Invalid printer template',
        detail: 'Could not find barcode token in template. Please fill in the ' +
        'format string correctly in template and reassign it to the printer to continue.'});
      return;
    }
    this.printPoolId(laneId, formatStringOriginal);
  }

  validateAllLibStatusAndConfirm(laneId){
    this.selectedLaneIdForCompleteRun = laneId;

    if (this.getQcFailedCompleteRunQCFlag() ) {
      this.showRunConfirmation = true;
    } else {
      this.createRunQCReviewStatusForMint(laneId)
    }
  }

  getAbortLabel(){
    if(this.showRunConfirmation) {
      return this.checkForONTRun() ? "Run QC Failed, create a Copy of this Run for Redo" : "Abort current run and create duplicate";
    }
   return "Abort the Run"
  }

  createRunQCReviewStatusForMint(laneId: string) {
    let reqObj = {}
    let runQcStatusList = []
    let allLibs =[];
    reqObj['runId'] = this.selectedRun.runId;
    reqObj['laneId'] = laneId;
    let laneNo = laneId.substring(laneId.lastIndexOf(" ") + 1)
    let runId = "ID" + this.selectedRun.runId
    if (this.POOL_DISABLED_STATES.has(this.selectedRun.status) && this.laneViewMap.has(laneId)) {
      runQcStatusList = this.laneViewMap.get(laneId).map(lib =>
        this.getRunQCStatusObj(laneNo, lib, runId,allLibs)
      )

    } else if(this.laneViewMap.has(laneId)) {
      this.laneViewMap.get(laneId).forEach(lib => {

        if (lib['containedLibs'] && this.containerLibMap.has(lib['libraryId'])) {
          allLibs.push(lib['libraryId'])
          let containedLibs = this.containerLibMap.get(lib['libraryId']).map(containedLib =>
            this.getRunQCStatusObj(laneNo, containedLib, runId,allLibs))
          runQcStatusList = [...runQcStatusList, ...containedLibs]
        } if (!lib['containedLibs']) {
          runQcStatusList.push(this.getRunQCStatusObj(laneNo, lib, runId,allLibs))
          allLibs.push(lib['libraryId'])
        }

      })
    }
    reqObj['runQcStatusList'] = runQcStatusList;
    reqObj['allLib'] = allLibs;
    reqObj['labId'] = this.selectedLabId;
    reqObj['updaterunFlag'] =this.getCountOfnotCompleteRunQCFlag() ==1
    reqObj['runReviewFinishedPUID'] = this.puid;
    if (this.selectedRun.runReviewStartedPUID)
    {
      reqObj['runReviewStarted'] = true;
    } else {
      reqObj['runReviewStarted'] = false;
    }
    reqObj['puid'] = this.puid;
    reqObj['currentDateTime'] = new Date();
    this.sendQCStatusToMINT(reqObj)
  }

  isCompleteDnPDisabled(lane: LaneViewDataDTO) {
    return !((lane.statusOfTheLane == DP_STARTED && lane.hamiltonFileGenerated) || (lane.allLibsDPWaiting))
  }

  completeDnP(lane: LaneViewDataDTO) {
    this.currentBusyLane = lane.laneId;
    let libraryIds = [];
    for (let library of this.laneViewMap.get(lane.laneId)) {
      libraryIds.push(library.libraryId);
    }

    let requestObj: RunLaneUpdateDTO = {
      'lab': this.selectedLabId,
      'runId': this.selectedRun.runId,
      'laneId': lane.laneId,
      'libraryIds': libraryIds,
      'concentration': lane.finalConcentration
    }

    this.runplanProcessService.startCompletionDnP(requestObj).subscribe(
      result => {
        this.currentBusyLane = '';
        this.prepareCompletionDialog(lane, result.data);
      },
      error => {
        this.currentBusyLane = '';
        this.handleError(error);
      }
    );
  }

  prepareCompletionDialog(lane: LaneViewDataDTO, completDnPDTO: any) {
    if(completDnPDTO['dpReadyLibs'] && completDnPDTO['dpReadyLibs'].length > 0) {
      this._messagesService.addErrorMessage({severity: 'error', summary: 'Automatic pooling must be completed.',
        detail: completDnPDTO['dpReadyLibs'].length + ' libraries are yet to be pooled. Please pool all ready libraries before performing next steps.'});
      return;
    }

    this.currentlyUsedLane = lane;
    if(!completDnPDTO['tdfMore'] || completDnPDTO['tdfMore'].length == 0) {
      this.executeCompleteDnPWithoutLibUpdate(lane);
      return;
    }

    // Formation of completion dialog required UI
    this.libTdfMore = completDnPDTO['tdfMore'];
    this.librarySuggestionMap = new Map(Object.entries(completDnPDTO['suggestionMap']));
    this.libraryTdfMap = new Map(Object.entries(completDnPDTO['tdfMap']));
    this.libraryPlateMap = new Map(Object.entries(completDnPDTO['libraryPlateMap']));
    this.plateLibraryMap = new Map(Object.entries(completDnPDTO['plateLibraryMap']));
    this.sortTdfLists();
    this.dnPErrors = null;
    this.showEbDilutionTable = false;
    this.disableDnPUpdate = true;
    this.manualPoolingPopUp = true;
    this.completionLibraryBarcode = null;
    this.completionPoolId = null;
    this.completionPlateBarcode = null;
    this.completionPlatePosition = null;
    this.adviceString = null;
    this.libraryTdf = null;
    setTimeout(() => {
      this.blocked = false;
      document.getElementById("poolIdDnP").focus();
    }, 50);
  }

  sortTdfLists() {
    this.libTdfMore.sort((lib1, lib2) => {
      if(this.libraryPlateMap.has(lib1) && !this.libraryPlateMap.has(lib2)) {
        return -1;
      } else if(!this.libraryPlateMap.has(lib1) && this.libraryPlateMap.has(lib2)) {
        return 1;
      } else {
        return 0;
      }
    });
  }

  executeCompleteDnPWithoutLibUpdate(lane: LaneViewDataDTO) {
    this.currentBusyLane = lane.laneId;
    let currentTime = new Date();
    let runUpdateRequired = (this.laneViewList.filter(lane => (lane.laneId != this.currentlyUsedLane.laneId && lane.statusOfTheLane != DP_COMPLETED)).length == 0 && this.laneViewList.length == this.flowcellData.logicalLanes);
    let exportFileName = this.datepipe.transform(new Date(), "yyyyMMdd_HHmmss") + "_DP_Data_" + this.selectedRun.runId + ".xlsx";
    let requestObj = {
      'labId': this.selectedLabId,
      'laneId': this.currentBusyLane,
      'runId': this.selectedRun.runId,
      'laneUpdate': true,
      'runUpdate': runUpdateRequired,
      'completionPuid': this.puid,
      'completionDatetime': currentTime,
      'exportFileName' : exportFileName,
      'labName' : this.selectableLab.lab.name
    };

    this.runplanProcessService.endCompletionDnP(requestObj).subscribe(
      _result => {
        this.currentBusyLane = '';
        if(runUpdateRequired) {
          this._messagesService.addSuccessMessage({severity: 'success', summary: 'Dilution and Pooling completed for Run!'});
          this.selectedRun.status = DP_COMPLETED;
          this.selectedRun.dilutionAndPoolingCompletedPUID = this.puid,
          this.selectedRun.dilutionAndPoolingCompletedDateTime = currentTime;
          this.selectedRun.dpDataExportFileName = exportFileName;
        } else {
          this._messagesService.addSuccessMessage({severity: 'success', summary: 'Dilution and Pooling completed for ' + lane.laneId });
        }

        lane.statusOfTheLane = DP_COMPLETED;
        this.updateLaneStatusForDnP(lane.laneId, DP_COMPLETED);
      },
      error => {
        this.currentBusyLane = '';
        this.handleError(error);
      }
    );
  }

  showCompleteButton() {
    return (this.libTdfMore.length == 1);
  }

  shiftFocusToLibraryDnP() {
    if(!this.completionPoolId || this.completionPoolId.trim() == '') {
      this.dnPErrors = 'Pool ID empty. Please scan the pool.';
      return;
    }

    if(this.completionPoolId != (this.selectedRun.runId +  "_" +this.currentlyUsedLane.laneId.replace(/\D/g, ""))) {
      this.dnPErrors = 'Wrong pool scanned.';
      this.completionPoolId = '';
      document.getElementById("poolIdDnP").focus();
      return;
    }

    this.completionLibraryBarcode = '';
    this.completionPlateBarcode = '';
    this.completionPlatePosition = '';
    document.getElementById("libraryIdDnP").focus();
  }

  validateLibrary() {
    if(!this.completionPoolId || this.completionPoolId.trim() == '') {
      this.dnPErrors = 'Pool ID empty. Please scan the Pool.';
      document.getElementById("poolIdDnP").focus();
      return;
    }

    if(this.completionPoolId != (this.selectedRun.runId +  "_" + this.currentlyUsedLane.laneId.replace(/\D/g, ""))) {
      this.dnPErrors = 'Wrong pool scanned.';
      this.completionPoolId = '';
      document.getElementById("poolIdDnP").focus();
      return;
    }

    if(!this.completionLibraryBarcode || this.completionLibraryBarcode.trim() == '') {
      if(this.plateLibraryMap.size > 0) {
        this.completionPlateBarcode = '';
        this.completionPlatePosition = '';
        document.getElementById("plateIdDnP").focus();
        return;
      } else {
        this.dnPErrors = "Scan library barcode to continue";
        return;
      }
    }

    if(this.libraryPlateMap.has(this.completionLibraryBarcode)) {
      let plateInfo = this.libraryPlateMap.get(this.completionLibraryBarcode).split(" - ");
      this.completionPlateBarcode = plateInfo[0];
      this.completionPlatePosition = plateInfo[1];
    }

    this.executeLibraryBarcodeOpertions();
  }

  resetInputsForLibrary() {
    this.completionPlateBarcode = '';
    this.completionPlatePosition = '';
    this.disableCompletion();
  }

  resetInputsForPlateBarcode() {
    this.completionLibraryBarcode = '';
    this.completionPlatePosition = '';
    this.disableCompletion();
  }

  resetInputForPlatePosition() {
    this.completionLibraryBarcode = '';
    this.disableCompletion();
  }

  isPlateScanDisabled() {
    return (this.plateLibraryMap?.size == 0);
  }

  executeLibraryBarcodeOpertions() {
    if(!this.libraryTdfMap.has(this.completionLibraryBarcode)) {
      this.dnPErrors = 'Library not found. Library not found on lane.';
      this.completionLibraryBarcode = '';
      document.getElementById("libraryIdDnP").focus();
      return;
    }

    if(!this.librarySuggestionMap.has(this.completionLibraryBarcode)) {
      this.dnPErrors = 'Manual Pooling not required. Library has acceptable tdf. Please scan next library';
      this.completionPoolId = '';
      this.completionLibraryBarcode = '';
      this.completionPlateBarcode = '';
      this.completionPlatePosition = '';
      document.getElementById("poolIdDnP").focus();
      return;
    }

    let libraryTdfNum = this.libraryTdfMap.get(this.completionLibraryBarcode);
    if(libraryTdfNum < 80) {
      this.adviceString = "Spike the pool with " + this.librarySuggestionMap.get(this.completionLibraryBarcode).toFixed(3) + " µl of this Library";
    } else if(libraryTdfNum > 80000) {
      this.thirdDilutionValue = this.librarySuggestionMap.get(this.completionLibraryBarcode);
      this.adviceString = "Spike the pool with 6 µl of Dilution 3";
      this.showEbDilutionTable = true;
    }
    this.libraryTdf = libraryTdfNum.toFixed(3);
    this.disableDnPUpdate = false;
  }

  validatePlateBarcode() {
    if(!this.completionPoolId || this.completionPoolId.trim() == '') {
      this.dnPErrors = 'Pool ID empty. Please scan the Pool.';
      document.getElementById("poolIdDnP").focus();
      return;
    }

    if(this.completionPoolId != (this.selectedRun.runId +  "_" + this.currentlyUsedLane.laneId.replace(/\D/g, ""))) {
      this.dnPErrors = 'Wrong pool scanned.';
      this.completionPoolId = '';
      document.getElementById("poolIdDnP").focus();
      return;
    }

    if(!this.completionPlateBarcode || this.completionPlateBarcode.trim() == "") {
      document.getElementById("libraryIdDnP").focus();
    } else {
      document.getElementById("platePosDnP").focus();
    }
  }

  validatePlatePosition() {
    if(!this.completionPoolId || this.completionPoolId.trim() == '') {
      this.dnPErrors = 'Pool ID empty. Please scan the Pool.';
      document.getElementById("poolIdDnP").focus();
      return;
    }

    if(this.completionPoolId != (this.selectedRun.runId +  "_" + this.currentlyUsedLane.laneId.replace(/\D/g, ""))) {
      this.dnPErrors = 'Wrong pool scanned.';
      this.completionPoolId = '';
      document.getElementById("poolIdDnP").focus();
      return;
    }

    if(!this.completionPlateBarcode || this.completionPlateBarcode.trim() == "" ) {
      this.completionPlatePosition = '';
      document.getElementById("plateIdDnP").focus();
      return;
    }

    if(!this.completionPlatePosition || this.completionPlatePosition.trim() == "") {
      this.dnPErrors = "Enter position of the library in the scanned plate";
      return;
    }

    let plateInfo = this.completionPlateBarcode + " - " + this.completionPlatePosition;
    if(this.plateLibraryMap.has(plateInfo)) {
      this.completionLibraryBarcode = this.plateLibraryMap.get(plateInfo);
      this.executeLibraryBarcodeOpertions();
    } else {
      this.dnPErrors = "Invalid plate position. No manual pooling eligible sample present at this plate position";
      this.completionPlateBarcode = '';
      this.completionPlatePosition = '';
      document.getElementById("plateIdDnP").focus();
    }
  }

  getLibraryPlatePosView(libraryList: string[]) {
    let platePosList = [];
    libraryList.forEach(lib => {
      if(this.libraryPlateMap.has(lib)) {
        platePosList.push(this.libraryPlateMap.get(lib));
      } else {
        platePosList.push("N/A - N/A");
      }
    });

    if(platePosList.length > 0) {
      return "(" + platePosList.join(", ") + ")"
    }
    return null;
  }

  updateCurrentAndInitializeNextLibrary() {
    let spikeVol = 0;
    let ebVolDilution3 = 0;

    ebVolDilution3 = this.librarySuggestionMap.get(this.completionLibraryBarcode);

    let requestObj = {
      'labId': this.selectedLabId,
      'libraryBarcode': this.completionLibraryBarcode,
      'spikeVol': spikeVol,
      'ebVolDilution3': ebVolDilution3,
      'laneUpdate': false,
      'runUpdate': false,
      'runId' :this.selectedRun.runId
    };

    this.disableDnPUpdate = true;
    this.runplanProcessService.endCompletionDnP(requestObj).subscribe(
      _result => {
        this.disableDnPUpdate = false;
        this.updateLibraryWithStatus(this.currentlyUsedLane.laneId, this.completionLibraryBarcode);
        this._messagesService.addSuccessMessage({severity: 'success', summary: 'Manual Pooling Success!', detail: 'Successfully updated library'});
        this.refreshToNewLibraryInput();
      },
      error => {
        this.disableDnPUpdate = false;
        this.handleError(error);
      }
    );
  }

  updateLibraryWithStatus(laneId: string, libraryBarcode: string) {
    let librariesInLane = this.laneViewMap.get(laneId);
    for(let lib of librariesInLane) {
      if(lib.libraryBarcode == libraryBarcode) {
        lib['status'] = DP_COMPLETED;
        lib['manualPooling'] = true;
      }
    }
    this.laneViewMap.set(laneId, librariesInLane);
  }

  private refreshToNewLibraryInput() {
    this.libTdfMore = this.libTdfMore.filter(lib => lib != this.completionLibraryBarcode);

    if(this.libraryPlateMap.has(this.completionLibraryBarcode)) {
      let plateInfo = this.libraryPlateMap.get(this.completionLibraryBarcode);
      this.plateLibraryMap.delete(plateInfo);
      this.libraryPlateMap.delete(this.completionLibraryBarcode);
    }

    this.disableDnPUpdate = true;
    this.showEbDilutionTable = false;
    this.libraryTdf = null;
    this.completionPoolId = '';
    this.completionLibraryBarcode = '';
    this.completionPlateBarcode = '';
    this.completionPlatePosition = '';
    this.adviceString = null;
    document.getElementById("poolIdDnP").focus();
  }

  finalizeCompleteDnP() {
    let currentTime = new Date();
    let runUpdateRequired = (this.laneViewList.filter(lane => (lane.laneId != this.currentlyUsedLane.laneId && lane.statusOfTheLane != DP_COMPLETED)).length == 0);

    let libraryTdfNum = this.libraryTdfMap.get(this.completionLibraryBarcode);
    let tdfHigh: boolean;
    let spikeVol = 0;
    let ebVolDilution3 = 0;

    if(libraryTdfNum < 80) {
      tdfHigh = false;
      spikeVol = this.librarySuggestionMap.get(this.completionLibraryBarcode);
    } else if(libraryTdfNum > 80000) {
      tdfHigh = true;
      ebVolDilution3 = this.librarySuggestionMap.get(this.completionLibraryBarcode);
    }
    let exportFileName = this.datepipe.transform(new Date(), "yyyyMMdd_HHmmss") + "_DP_Data_" + this.selectedRun.runId + ".xlsx";
    let requestObj = {
      'labId': this.selectedLabId,
      'laneId': this.currentlyUsedLane.laneId,
      'runId': this.selectedRun.runId,
      'libraryBarcode': this.completionLibraryBarcode,
      'tdfHigh': tdfHigh,
      'spikeVol': spikeVol,
      'ebVolDilution3': ebVolDilution3,
      'laneUpdate': true,
      'runUpdate': runUpdateRequired,
      'completionPuid': this.puid,
      'completionDatetime': currentTime,
      'exportFileName': exportFileName
    };

    this.disableDnPUpdate = true;
    this.runplanProcessService.endCompletionDnP(requestObj).subscribe(
      _result => {
        this.manualPoolingPopUp = false;
        this.updateLibraryWithStatus(this.currentlyUsedLane.laneId, this.completionLibraryBarcode);
        if(runUpdateRequired) {
          this._messagesService.addSuccessMessage({severity: 'success', summary: 'Dilution and Pooling completed for Run!'});
          this.selectedRun.status = DP_COMPLETED;
          this.selectedRun.dilutionAndPoolingCompletedPUID = this.puid,
          this.selectedRun.dilutionAndPoolingCompletedDateTime = currentTime;
          this.selectedRun.dpDataExportFileName = exportFileName;
        } else {
          this._messagesService.addSuccessMessage({severity: 'success', summary: 'Dilution and Pooling completed for ' + this.currentlyUsedLane.laneId });
        }
        this.currentlyUsedLane.statusOfTheLane = DP_COMPLETED;
        this.updateLaneStatusForDnP(this.currentlyUsedLane.laneId, DP_COMPLETED);
        this.currentlyUsedLane.allLibsDPWaiting = false;
      },
      error => {
        this.disableDnPUpdate = false;
        this.handleError(error);
      }
    );
  }

  disableCompletion() {
    this.dnPErrors = null;
    this.disableDnPUpdate = true;
    this.showEbDilutionTable = false;
    this.libraryTdf = null;
    this.adviceString = null;
  }

  showDilutionView() {
    return this.selectedRun.status == DP_STARTED;
  }

  exportDPData() {
    let dpDataExportRequest : RunDPDataExportRequest = this.getDPDataExportRequest()
    this.blocked = true;
    this.runplanProcessService.downloadSampleSheet("dp_export", JSON.stringify(dpDataExportRequest)).subscribe(
      result=>{
        this.blocked = false
        this._messagesService.addSuccessMessage({
          severity:'success', summary:'Initiating File Download', detail:''
        })
        let blob = new Blob([result.fileContent], { type: 'application/octet-stream' });
        let fileName = this.datepipe.transform(new Date(), "yyyyMMdd_HHmmss") + "_DP_Data_" + this.selectedRun.runId + ".xlsx";
        saveByFileSaver(blob, fileName);
      }, error=>{
        this.blocked = false;
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Export Failed!', detail: 'Error occurred while exporting DP Data....Please contact support.'});
      }
    )
  }

  getDPDataExportRequest(): RunDPDataExportRequest {
    let dpDataExportRequest : RunDPDataExportRequest = new RunDPDataExportRequest;

    dpDataExportRequest.labId = this.selectedLabId;
    dpDataExportRequest.runId = this.selectedRun.runId;

    this.selectedRun.runLanes.forEach(lane=>{
      lane.runLanes.forEach(ipu=>{
        dpDataExportRequest.libraryIds = dpDataExportRequest.libraryIds.concat(ipu.libraryId)

        ipu.libraryId.forEach(libraryId=>{
          let libLaneData : LibLaneData = new LibLaneData;
          libLaneData.laneId = lane.laneId;
          libLaneData.libraryId = libraryId;
          libLaneData.phix = ipu.phiXPercentage;
          dpDataExportRequest.libLaneData.push(libLaneData)
        })
      })
    })

    return dpDataExportRequest;
  }

  actionHandler() {
    // handle action for dropdown

    switch(this.runActionSelection) {
      case 'remove':
        this.showRemovalSideBar();
        break;
      case 'changeConcentration':
        this.showConcentrationChangeSlider();
        break;
      default:
        break;
    }
  }

  showConcentrationChangeSlider() {
    this.showChangeConcentrationSidebar = false;
    this.barcodesToChangeConcentration = [];
    if(this.librarySelectionList && this.librarySelectionList.length > 0) {
      let laneId = this.libLaneGXPMap.get(this.librarySelectionList[0].libraryBarcode)['lane'];
      if(!this.isStatusPresent(laneId, [DP_STARTED, DP_COMPLETED])) {
        this.barcodesToChangeConcentration = this.barcodesToChangeConcentration.concat(this.librarySelectionList.map(lib => lib.libraryBarcode));
      }
    }

    this.laneSelectionMap.forEach((value: any[], key: string) => {
      if(!this.isStatusPresent(key, [DP_STARTED, DP_COMPLETED])) {
        this.barcodesToChangeConcentration = this.barcodesToChangeConcentration.concat(value.map(lib => lib.libraryBarcode));
      }
    });

    if(this.barcodesToChangeConcentration.length > 0) {
      this.showChangeConcentrationSidebar = true;
    } else {
      this._messagesService.addErrorMessage({severity: 'error', summary: 'No eligible libraries!',
        detail: 'No eligible libraries selected. Please select only libraries in lanes that have not started D&P.'});
    }
  }

  isStatusPresent(laneId: string, statusList: string[]) {
    let isStatusSame = false;
    this.selectedRun.runLanes.forEach(lane => {
      if(lane.laneId == laneId && statusList.includes(lane.statusOfTheLane)) {
        isStatusSame = true;
      }
    });

    return isStatusSame;
  }

  changeConcentrationForSelectedLibs() {
    let requestObj: RunLaneUpdateDTO = {
      'lab': this.selectedLabId,
      'runId': this.selectedRun.runId,
      'libraryIds': this.barcodesToChangeConcentration,
      'concentration': this.userConcentration
    };

    this.runplanProcessService.updateLibraryConcentration(requestObj).subscribe(
      _result => {
        let selectedBarcodeSet = new Set(this.barcodesToChangeConcentration);
        // change concentration for all samples selected
        this.laneViewMap.forEach((value: any[], key: string) => {
          value.forEach(lib => {
            if(selectedBarcodeSet.has(lib['libraryBarcode'])) {
              lib.concentration = this.userConcentration;
            }
          });
        });

        this.userConcentration = undefined;
        this.barcodesToChangeConcentration = [];
        this.showChangeConcentrationSidebar = false;
        this._messagesService.addSuccessMessage({severity: 'success', summary:'Concentration updated successfully!'});
      },
      error => {
        this.handleError(error);
      }
    );
  }

  isConcentrationChangeDisabled() {
    return (this.userConcentration == null
      || this.userConcentration == undefined
      || this.barcodesToChangeConcentration.length == 0);
  }

  closeSidebar() {
    this.showRunConfirmation = false;
    this.processViewSidebar = false;
  }

  checkSequencerTypeForPrepareData(event: any) {
    if(this.checkForONTRun()) {
      this.scannedFlowCellID = this.selectedRun.flowCellId
      this.prepareDataOverlay.toggle(event)
      setTimeout(() => {
        document.getElementById("flowcell-id-input").focus();
      }, 50);
    } else {
      this.saveRunStatus('PREPARE_DATA_FOR_ANALYSIS')
    }
  }

  checkForONTRun() {
    return this.selectedRun?.sequencerType.endsWith("ION");
  }

  getPrepareDataOverlayAcceptButtonLabel() {
    return !this.selectedRun.flowCellId ? 'Continue' : 'Yes'
  }

  getPrepareDataOverlayRejectButtonLabel() {
    return !this.selectedRun.flowCellId ? 'Cancel' : 'No'
  }

  getFlowcellIDInputMessage() {
    return !this.selectedRun.flowCellId ?
      'Enter FlowCell ID to generate ONT Analysis Sheet:' :
      'There is already a FlowCell ID and an Analysis Sheet stored with this run. Do you want to replace the existing Analysis Sheet?'
  }

  saveFlowCellIDWithRun() {
    this.selectedRun.flowCellId = this.scannedFlowCellID
    this.saveRunStatus('PREPARE_DATA_FOR_ANALYSIS')
  }

  checkIfLoggedInUserIsMDMAdmin() {
    const roles = this.getRolesFromAccessToken();
    if(roles.length <= 0) {
      return false
    }

    return roles.includes(environment.AZURE_MDM_GROUP_ID);
  }

  getRolesFromAccessToken() {
    const authUtil = new AuthUtil()
    const accessToken = authUtil.getAccessToken()
    if(accessToken)
    {
      const access_token = jwt_decode(accessToken);
      return access_token.roles;
    }
    return [];
  }

  disableStartManualRunReview() {
    return this.checkForONTRun() ? (this.selectedRun?.status !== 'SEQ_RUN_FINISHED') : (this.selectedRun?.status !== 'PA_FINISHED')
  }

  disableManualRunReview() {
    return this.checkForONTRun() ? this.selectedRun?.status !== 'MANUAL_RUNQC_STARTED' : true;
  }

  getContinueRadioButtonLabel() {
    return this.checkForONTRun() && this.selectedRun.status === 'MANUAL_RUNQC_STARTED' ? 'Run QC Passed' : 'Continue the Run'
  }

  private updateManualRunQCStatusForONTRun() {

    const manualRunQCReviewRequest = new ManualRunQCReviewRequest();
    manualRunQCReviewRequest.runId = this.selectedRun.runId;
    manualRunQCReviewRequest.allLib = this.selectedRun.libraryIds;
    manualRunQCReviewRequest.puid = this.puid;
    manualRunQCReviewRequest.runReviewStarted = true;
    manualRunQCReviewRequest.currentDateTime = new Date();
    manualRunQCReviewRequest.updaterunFlag = true;
    manualRunQCReviewRequest.labId = this.selectedLabId;
    manualRunQCReviewRequest.runQcStatusList = [this.getManualRunQCEventForONT()]
    manualRunQCReviewRequest.runQCAction = this.sequencingRunContinuationValue;
    manualRunQCReviewRequest.ontRun = true;
    manualRunQCReviewRequest.sequencerType = this.selectedRun.sequencerType;

    this.sendQCStatusToMINT(manualRunQCReviewRequest)
  }

  private getManualRunQCEventForONT() {
    const manualRunQCEvent = new ManualRunQCEventPayload();
    manualRunQCEvent.run = this.selectedRun.runId;
    manualRunQCEvent.labName = this.selectableLab.lab.name;
    manualRunQCEvent.runQCStatus = this.sequencingRunContinuationValue === 'complete' ? 'QC Passed' : 'QC Failed'
    manualRunQCEvent.sequencerType = this.selectedRun.sequencerType;
    return manualRunQCEvent;
  }
}
